/**
 * @license
 * @qwik.dev/core 2.0.0-beta.38-dev+b06a0bb
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as De, isBrowser as We } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as Fe } from "@qwik.dev/core/preloader";

const Ve = !1;

const ze = (t, ...n) => Be(!1, t, ...n);

const Be = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const He = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const Qe = (t, n, e, s, o = !1) => {
    const r = He(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const Je = (t, n, e) => {
    const s = He(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ye = (t, n, e) => He(t, n, e) >= 0;

const Ge = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Ze = t => typeof t === "object" && t !== null;

const Ke = t => Array.isArray(t);

const tr = t => typeof t === "string";

const nr = t => typeof t === "function";

const er = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Be(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const rr = "<sync>";

const ir = t => typeof t === "function" && typeof t.getSymbol === "function";

const Wd = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const sr = "q:type";

const or = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const cr = 124;

const fr = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

const ar = t => /[A-Za-z]/.test(t);

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const hr = "q:renderFn";

const dr = "q:targetEl";

const pr = "⚡️";

const $r = "q:slot";

const yr = "q:sparent";

const wr = "q:s";

const mr = "[q\\:patch]";

const _r = "q:r";

const vr = "q:rp";

const br = "q:ebc";

const Vd = "q:ebf";

const Er = "q:style";

const gr = "style[q\\:style]";

const Sr = gr + ",style[q\\:sstyle]";

const kr = "q:sstyle";

const Rr = "q:ctx";

const Pr = "q:brefs";

const Tr = (t, n) => t["qFuncs_" + n] || [];

const Ar = "q:base";

const Mr = "q:container-island";

const Ir = "/" + Mr;

const qr = "q:ignore";

const Nr = "/" + qr;

const xr = "q:container";

const Cr = "/" + xr;

const Lr = "q:cursorBoundary";

const Or = "q:template";

const jr = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const Xr = "http://www.w3.org/1999/xhtml";

const Fr = "http://www.w3.org/2000/svg";

const Dr = "http://www.w3.org/1998/Math/MathML";

const Wr = "qRender";

const Vr = "q:id";

const Ur = "q:key";

const zr = "q:props";

const Br = "q:seq";

const Hr = "q:seqIdx";

const Qr = "q:p";

const Jr = "q:ps";

const Gr = ":on";

const Zr = ":onIdx";

const Kr = ":onFlags";

const ti = ":nearestCursorBoundary";

const ni = ":";

const ei = "dangerouslySetInnerHTML";

const ii = 100;

const si = t => {
    try {
        return !!t && typeof t == "object" && typeof t.then === "function";
    } catch {
        return !1;
    }
};

const oi = (t, n, e) => {
    try {
        const s = t();
        return si(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const li = (t, n) => si(t) ? t.then(n) : n(t);

const ui = t => new Promise(n => {
    setTimeout(n, t);
});

const ci = t => {
    throw t;
};

function n(t, n = ci) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!si(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = ii;
    const r = async e => {
        for (;si(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!si(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const fi = t => pr + t;

const ai = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + fi(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const hi = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + di(t.slice(s, -1));
        }
    }
    return null;
}

const di = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = pi(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const pi = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const $i = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const yi = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const wi = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const mi = t => {
    if (!t) {
        return "";
    }
    if (tr(t)) {
        return t.trim();
    }
    const n = [];
    if (Ke(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = mi(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const _i = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const vi = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Ke(t)) {
            throw er(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(_i(e) + ":" + bi(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = mi(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = vi(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const bi = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => yi.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Ei = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.an = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const gi = () => ({
    isServer: De,
    importSymbol(t, n, e) {
        if (De) {
            const t = Wd(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw er(6, [ e ]);
        }
        if (!n) {
            throw er(14, [ e ]);
        }
        if (!t) {
            throw er(13, [ n, e ]);
        }
        const s = Si(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Si = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Ar) ?? s, s);
    return new URL(e, o);
};

let ki = /*#__PURE__ */ gi();

const Ri = t => ki = t;

const Pi = () => ki;

const Ud = () => ki.isServer;

const zd = typeof document !== "undefined";

const Ti = !De && zd;

const Ai = Ti ? document : void 0;

const Mi = Ti && Ai.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const Ii = /\.[mc]?js$/;

const qi = t => {
    let n = Ni.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            hn: t,
            Ht: Ii.test(t) ? 0 : 3,
            dn: n,
            pn: 1,
            $n: performance.now(),
            yn: 0,
            wn: 0
        }))(t, e);
        Ni.set(t, n);
    }
    return n;
};

const Ni = new Map;

let xi = 0;

const Ci = [];

const Li = Ei(function Bd() {
    ji = !1;
    if (!Ci.length) {
        return;
    }
    const t = performance.now() + 10;
    let n = !1;
    for (;Ci.length; ) {
        const e = Ci[0];
        const s = e.pn;
        const o = 1 - s;
        if (!(o >= .99 || xi < 25)) {
            break;
        }
        Ci.shift();
        Vi(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Ci.length && !ji) {
        ji = !0;
        Li();
    }
});

const Oi = Ei(i);

let ji = !1;

let Xi = !1;

let Fi = !1;

const Di = [];

const Wi = () => {
    const t = Di[Di.length - 1];
    const n = t.mn;
    if (t.dn) {
        const e = t.Lt;
        if (e >= t.dn.length) {
            Di.pop();
            return !1;
        }
        const s = t.dn[e];
        t.Lt = e + 1;
        const o = qi(s.hn);
        if (o.pn === 0) {
            return !0;
        }
        const r = 1 - n.pn;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s._n);
        } else {
            const t = 1 - s._n * r;
            const n = s.vn;
            const e = t / n;
            i = Math.max(.02, o.pn * e);
            s.vn = e;
        }
        Di.push({
            mn: o,
            pn: i,
            bn: t.bn
        });
        return !0;
    }
    if (t.bn?.has(n)) {
        Di.pop();
        return !1;
    }
    const e = n.pn;
    n.pn = t.pn;
    if (e - n.pn < .01) {
        Di.pop();
        return !1;
    }
    if (n.dn?.length) {
        const e = t.bn || new Set;
        e.add(n);
        t.bn = e;
        t.dn = n.dn;
        t.Lt = 0;
        return !1;
    }
    Di.pop();
    return !1;
};

function i() {
    if (Fi || !Di.length) {
        return;
    }
    Xi = !1;
    Fi = !0;
    const t = Ti ? performance.now() + 10 : 0;
    let n = !1;
    for (;Di.length; ) {
        n = !0;
        const e = Wi();
        if (Ti && e && performance.now() >= t) {
            if (!Xi) {
                Xi = !0;
                Oi();
            }
            break;
        }
    }
    Fi = !1;
    n && Ti && Li();
}

const Vi = t => {
    if (t.Ht >= 2) {
        return;
    }
    xi++;
    const n = performance.now();
    t.yn = n - t.$n;
    t.Ht = 2;
    const e = Ai.createElement("link");
    e.href = new URL("undefined" + t.hn, Ai.baseURI).toString();
    e.rel = Mi;
    e.as = "script";
    e.onload = e.onerror = () => {
        xi--;
        const s = performance.now();
        t.wn = s - n;
        t.Ht = 4;
        e.remove();
        Li();
    };
    Ai.head.appendChild(e);
};

const Ui = (t, n) => {
    const e = qi(t);
    e && ((t, n) => {
        Di.unshift({
            mn: t,
            pn: n,
            bn: void 0
        });
    })(e, n);
};

Ti && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Ui(e, 0);
                }
            } else {
                Ui(t, 0);
            }
            Ti ? Oi() : i();
        })(t);
    }
});

const zi = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const Bi = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Hi = '"';

const Qi = "[";

const Ji = "]";

const Yi = ",";

const Gi = "2.0.0-beta.38-dev+b06a0bb";

const Zi = t => t.nodeType === 1;

const Ki = t => t.En;

const ts = Symbol();

class ns {
    [ts]=void 0;
}

const es = t => t === "foreignObject";

const rs = t => t === "svg" || es(t);

const is = t => t === "math";

function s(t, n, e, o = !1) {
    const r = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== ni && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(s(i, i.localName, e, o));
        }
    }
    return r;
}

const ss = {
    elementNamespace: Xr,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!iu(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && es(iu(t));
    let o = Xr;
    let r = 0;
    const i = typeof n === "string" || Rl(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return rs(t);
        }
        if (Rl(t)) {
            return rs(iu(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Fr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return is(t);
        }
        if (Rl(t)) {
            return is(iu(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Dr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Fr : e ? Dr : Xr;
        r = t.flags & 1536;
    }
    ss.elementNamespace = o;
    ss.elementNamespaceFlag = r;
    return ss;
}

class os {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [ts]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class ls extends os {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class us extends ls {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class cs extends os {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const fs = [];

const as = [];

function l(t, n) {
    const e = y(n).priority;
    let s = fs.length;
    for (let t = 0; t < fs.length; t++) {
        const n = y(fs[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    fs.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < fs.length; t++) {
        const n = fs[t];
        let e = !1;
        for (let t = 0; t < as.length; t++) {
            const s = as[t];
            if (Ru(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    as.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = fs.indexOf(t);
    if (s !== -1) {
        fs.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = as.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = as.length - 1;
    e !== s && (as[e] = as[s]);
    as.pop();
    n.o--;
    return !0;
}

const hs = new WeakMap;

const ds = ":nodeProps";

const ps = ":nodeDiff";

const $s = ":errorData";

const ys = ":signal";

const ws = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && dn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return hs.get(t) ?? null;
}

const ms = Symbol();

const _s = Symbol();

const vs = Symbol();

const bs = Symbol();

const Es = Symbol();

const gs = Symbol();

const Ss = [];

const ks = {};

Object.freeze(Ss);

Object.freeze(ks);

function w(t) {
    return new Proxy({}, new Rs(t));
}

class Rs {
    owner;
    ft=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === ms) {
            return this.owner.constProps;
        }
        if (n === _s) {
            return this.owner.varProps;
        }
        if (n === vs) {
            return this.owner;
        }
        if (n === bs) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = As(this.owner, n);
            n in this.owner.varProps && Ps(this, n);
        }
        return s instanceof oo ? s.value : s;
    }
    set(t, n, s) {
        if (n === vs) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === ms) {
            this.owner.constProps = s;
        } else if (n === _s) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === ks ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                Ts(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && Ts(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === ms || n === _s) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Ps(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Ps = (t, n) => {
    const e = da();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.un;
    s && Nn(t.owner._proxy, n, t, s);
};

const Ts = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ft, n);
    e && zu(t.$, t, e);
    return !!e;
};

const As = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const Ms = (t, n) => Is(t)?.[n] || qs(t)?.[n] || null;

const Is = t => {
    if (!t) {
        return null;
    }
    return _s in t ? "children" in t ? {
        ...t[_s],
        children: t.children
    } : t[_s] : t;
};

const qs = t => {
    if (!t) {
        return null;
    }
    return ms in t ? t[ms] : null;
};

const Ns = t => t && _s in t;

const xs = Symbol();

class Cs {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Ls = Symbol();

const Os = Symbol();

const js = Symbol();

function m(t, n, e) {
    t[ts] || (De && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Pr, new Map) : t[ts] = new Map);
    const o = t[ts];
    let r = o.get(n);
    if (!r) {
        r = new Cs(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Xs = (t, n) => (e, s) => {
    const o = je();
    o.un = m(t, ":");
    o.$ = n || void 0;
    return Ce(o, () => {
        if (nr(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Fu(e)) {
            return e.value;
        }
        if (Ze(e) && ec(e)) {
            Nn(Zu(e), js, Gu(e), o.un);
            return e;
        }
        throw er(2);
    });
};

class Fs {
    Ot;
    ft=void 0;
    $=null;
    gn=null;
    constructor(t, n) {
        this.$ = t || da()?.$ || null;
        this.Ot = n;
    }
    trigger() {
        zu(this.$, this, this.ft);
    }
    force() {
        zu(this.$, this, this.ft);
    }
    get untrackedValue() {
        return this.Ot;
    }
    set untrackedValue(t) {
        this.Ot = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = da();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.un;
        if (e) {
            const t = De;
            const s = this.ft ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            Du(s, e);
            Wu(e, this);
            if (t) {
                const t = Uu(n.$, this.$);
                o && t?.Sn?.(this, e, null);
                Vu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Ot) {
            this.Ot = t;
            zu(this.$, this, this.ft);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Ot
        };
    }
}

class Ds {
    kn;
    Rn=null;
    Pn=!1;
    Tn=!0;
    constructor(t, n, e) {
        this.kn = t;
        if (n !== void 0) {
            this.info = n;
            this.An = e;
        }
    }
    get track() {
        return this.Mn ||= Xs(this.kn, this.kn.$);
    }
    get abortSignal() {
        return (this.In ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.kn.Ot;
        if (t !== xs) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.qn ||= []).push(t);
    }
}

class Ws extends Fs {
    jt;
    h;
    [ts]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || da()?.$, xs);
        this.jt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Ot = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.Dt = r;
            this.Wt = [];
        }
        s.timeout && (this.Vt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
        s.allowStale === !1 && (this.h |= 128);
        const i = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        i && (this.expires = i);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    invalidate(t) {
        if (arguments.length > 0) {
            this.Nn = t;
            this.An = this.An === void 0 ? 1 : this.An + 1;
        }
        if (this.h & 512) {
            this.xn(!0, this.h & 128);
            return;
        }
        this.h |= 1;
        const e = je();
        e.$ = this.$ || void 0;
        const s = n(Le.bind(this, e, this.p));
        si(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.Nn = void 0;
            if (this.Wt) {
                for (let t = 0; t < this.Wt.length; t++) {
                    this.Wt[t].Tn = !1;
                }
            } else {
                this.ot && (this.ot.Tn = !1);
            }
            this.Cn();
            super.value = t;
            this.Ln();
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.ot?.Rn) {
            if (this.Ot === xs || De) {
                throw this.ot?.Rn;
            }
            return this.Ot;
        }
        if (this.Xt) {
            throw this.Xt;
        }
        if (De && this.h & 64 && this.Ot === xs) {
            throw er(35);
        }
        return this.Ot;
    }
    set untrackedValue(t) {
        this.Ot = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = da();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.un;
            if (t) {
                Du(this.yt ||= new Set, t);
                Wu(t, this);
                Vu(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Ft) {
            this.Ft = t;
            zu(this.$, this, this.yt);
        }
    }
    get untrackedPending() {
        this.p();
        if (De && this.ot?.Rn) {
            throw this.ot?.Rn;
        }
        return !!this.Ft;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = da();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.un;
            if (t) {
                Du(this.wt ||= new Set, t);
                Wu(t, this);
                Vu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.Xt) {
            this.Xt = t;
            zu(this.$, this, this.wt);
        }
    }
    get untrackedError() {
        this.p();
        if (De && this.ot?.Rn) {
            throw this.ot?.Rn;
        }
        return this.Xt;
    }
    get expires() {
        return this.Mt || 0;
    }
    set expires(t) {
        this.Cn();
        this.Mt = t;
        this.Mt && this.On() && this.Ln();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Mt && this.On()) {
            this.Cn();
            this.Ln();
        }
    }
    get interval() {
        const t = this.Mt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    xn(t, n) {
        this.h |= 1;
        this.Cn();
        n && (this.Ot = xs);
        t && (this.ft?.size || this.yt?.size || this.wt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.ot && this.jn(this.ot, t);
    }
    _t() {
        if (!(this.h & 32) || this.On()) {
            return;
        }
        if (!We) {
            return;
        }
        setTimeout(() => {
            this.On() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.ot?.Rn; ) {
            await (this.ot?.Rn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.Xn();
        }
        const t = this.jt;
        Xu(t);
        const e = this.ot;
        if (e && !e.Pn) {
            e.Pn = !0;
            e.In?.abort();
            this.Fn(e);
        }
        const s = new Ds(this, this.Nn, this.An);
        this.ot = s;
        let o;
        try {
            o = this.Dn(t.resolved, s);
        } catch (t) {
            if (si(t)) {
                throw t;
            }
            s.An === this.An && (this.Nn = void 0);
            this.h &= -2;
            this.Wn(s, t);
            return;
        }
        if (si(o)) {
            this.h |= 512;
            this.h &= -2;
            let t = o;
            const e = () => {
                const n = t ?? this.Dn(this.jt.resolved, s);
                t = void 0;
                return n;
            };
            s.Rn = this.Vn(s, () => n(e));
            return;
        }
        s.An === this.An && (this.Nn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    Dn(t, n) {
        const e = t;
        if (this.h & 1024) {
            let t = da();
            t?.un && (t = {
                ...t,
                un: void 0
            });
            return Le(t, e, [ n ]);
        }
        const s = this.$ ||= da()?.$ || null;
        const o = m(this, ".");
        s && Rn(s, o);
        const r = je();
        r.$ = s || void 0;
        r.un = o;
        return Le(r, e, [ n ]);
    }
    Xn() {
        if (De && this.h & 64) {
            this.Ft = !0;
            this.$?.serializationCtx.It.add(this);
            return;
        }
        this.Cn();
        this.h &= -2;
        const t = this.ot;
        t && this.jn(t);
        const n = this.Dt === 0 ? Infinity : this.Dt ?? 1;
        if (this.Wt ? this.Wt.length >= n : t?.Rn) {
            this.h |= 1;
            return;
        }
        const e = this.An;
        const s = new Ds(this, this.Nn, e);
        this.ot = s;
        this.Wt && this.Wt.push(s);
        s.Rn = this.Un(s);
    }
    async Un(t) {
        let e = this.jt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.jt.resolve();
            if (t.In?.signal.aborted) {
                t.Rn = null;
                return;
            }
        }
        this.Vt && (this.zn = setTimeout(() => {
            const n = Error(`timeout ${this.Vt}ms`);
            this.Wn(t, n);
            t.In?.abort(n);
        }, this.Vt));
        return this.Vn(t, () => n(() => this.Dn(e, t)));
    }
    async Vn(t, n) {
        try {
            const e = n();
            let s;
            if (si(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.Rn = null;
            if (t.Tn) {
                const n = this.Wt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].Tn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.Rn = null;
            this.Wn(t, n);
        }
        if ((() => t === this.ot)()) {
            clearTimeout(this.zn);
            t.An === this.An && (this.Nn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedPending = !1;
                this.Ln();
            }
        }
    }
    Wn(t, n) {
        if (t !== this.ot || !t.Tn) {
            return;
        }
        t.Tn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = xs;
    }
    async an() {
        this.Cn();
        clearTimeout(this.zn);
        const t = this.ot;
        t && this.jn(t);
        this.Wt ? await Promise.all(this.Wt.map(t => t.Rn)) : await (t?.Rn);
    }
    Cn() {
        if (this.Bn !== void 0) {
            clearTimeout(this.Bn);
            this.Bn = void 0;
        }
    }
    Ln() {
        if (De || !this.Mt) {
            return;
        }
        this.Cn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.Bn = setTimeout(() => this.xn(t, n), this.Mt);
        this.Bn?.unref?.();
    }
    On() {
        return !!(this.ft?.size || this.yt?.size || this.wt?.size);
    }
    jn(t, n) {
        if (t.Pn) {
            return;
        }
        t.Pn = !0;
        t.In?.abort(n);
        t.Rn = li(t.Rn, () => this.Hn(t));
    }
    Fn(t) {
        const n = t.qn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    si(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Hn(t) {
        const n = () => {
            t.Rn = null;
            const n = this.Wt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.Fn(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const Vs = t => (n, ...e) => t.call(null, Ja(n), ...e);

class Us extends Ws {
    constructor(t, n) {
        super(t, n, 17);
    }
    Qn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Xu(this.jt);
        const t = wa(this.jt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Ot === xs ? e : this.Ot;
        const r = _a(() => this.Qn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Qn = !0;
        this.h &= -2;
        const i = this.Qn && r !== "undefined" || r !== this.Ot;
        if (i) {
            this.Ot = r;
            zu(this.$, this, this.ft);
        }
    }
}

class zs extends Ws {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const Bs = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Hs = (t, n) => new Ws(n?.container || null, t, Hu(n?.serializationStrategy || "always"), n);

const Qs = (t, n) => new zs(n?.container || null, t, Hu(n?.serializationStrategy || "always"), n);

const Js = t => new Us(null, t);

const Ys = t => new Fs(null, t);

const Gs = /*#__PURE__*/ Vs(Hs);

const Zs = /*#__PURE__*/ Vs(Qs);

const Ks = Vs(Js);

const to = t => t.value;

const no = (t, n) => t[n];

const eo = t => {
    if (t.length === 1) {
        if (Fu(t[0])) {
            return t[0].gn ||= new oo(null, to, t, null);
        }
        if (ec(t[0])) {
            return new oo(null, to, t, null);
        }
        return t[0].value;
    }
    return new oo(null, no, t, null);
};

const ro = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Ze(n)) {
        return n[e];
    }
    if (Fu(n)) {
        if (n instanceof oo) {
            return n;
        }
        return eo(t);
    }
    if (Ns(n)) {
        const s = n[ms];
        const o = n[_s];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return io(n, t);
        }
    } else {
        const s = Zu(n);
        if (s) {
            const n = s[e];
            return io(n, t);
        }
    }
    return n[e];
};

const io = (t, n) => Fu(t) ? t : eo(n);

const so = (t, n) => {
    const e = ro(t, n);
    if (e === Es) {
        return t[n];
    }
    return e;
};

class oo extends Fs {
    ut;
    lt;
    Rt;
    h;
    m=void 0;
    [ts]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, xs);
        this.ut = e;
        this.lt = n;
        this.Rt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, ys, this);
                yn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            zu(this.$, this, this.ft);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Ot;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = _a(() => this.lt(...this.ut), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Ot;
        if (n) {
            this.h |= 2;
            this.Ot = t;
        }
    }
    it() {
        return this.lt === to && Fu(this.ut[0]) ? this.ut[0] : this;
    }
    set value(t) {
        throw er(31);
    }
    get value() {
        return super.value;
    }
}

class lo {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class uo {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || zi(n) ? ks : n;
        this.constProps = !e || zi(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const co = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const fo = t => t instanceof uo;

const ao = (t, n, e) => {
    if (typeof t === "string") {
        const s = Ae(n);
        return la(s, () => {
            La(Oa(s, t));
            return e();
        });
    }
    return e();
};

function _(t, n) {
    return ao(this, n, () => {
        const t = Ca[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function v(t, n) {
    return ao(this, n, () => {
        const t = Ca[0];
        t.value = n.checked;
    });
}

function b(t, n) {
    return ao(this, n, () => {
        if (Ca) {
            for (let t = 0; t < Ca.length; t++) {
                const n = Ca[t];
                n instanceof zs && n.h & 64 && n.p();
            }
        }
    });
}

const ho = "bind:value";

const po = "bind:checked";

const $o = "passive:";

const yo = "preventdefault:";

const wo = Object.prototype.hasOwnProperty;

const mo = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(di(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const _o = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return di(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return di(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return di(t.slice(11, -1));
    }
    return null;
};

const vo = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = _o(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const bo = (t, n, e, s, o, r, i) => new uo(t, n, e, s, o, r, !1, i);

const Eo = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith($o)) {
                    r.push(o);
                    t.add(di(o.slice(8)));
                } else {
                    o.startsWith(yo) ? h.push(o) : _o(o) !== null ? s.push(o) : o === po ? a = e[o] : o === ho && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith($o)) {
                    i.push(s);
                    t.add(di(s.slice(8)));
                } else {
                    s.startsWith(yo) ? d.push(s) : _o(s) !== null ? o.push(s) : s === po ? a = n[s] : s === ho && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = mo(e, r, h, t, l);
            l = l || e !== n;
            e = vo(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = mo(n, i, d, t, u);
            u = u || n !== e;
            n = vo(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && wo.call(n, po) && delete n[po];
                if (e && wo.call(e, po)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[po];
                }
                n.checked = a;
                const t = Da(null, "_chk", v, null, [ a ]);
                if (e && wo.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = co(n, "q-e:input", t) || c;
                }
                c = co(n, "q-e:input", t) || c;
            } else if (f) {
                n && wo.call(n, ho) && delete n[ho];
                if (e && wo.call(e, ho)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[ho];
                }
                n.value = f;
                const t = Da(null, "_val", _, null, [ f ]);
                if (e && wo.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = co(n, "q-e:input", t) || c;
                }
                c = co(n, "q-e:input", t) || c;
            }
        }
        if (n && wo.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && wo.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new uo(t, n, e, s, o, r, c || !0, i);
};

const go = (t, n, e, s) => Po(t, n, s);

const So = (t, n, e, s, o) => Po(t, {
    ...e,
    ...n
}, o);

const ko = (t, n, e, s, o, r) => Po(t, {
    ...e,
    ...n,
    children: s
}, r);

const Ro = t => t.children;

const Po = (t, n, e, s, o) => Eo(t, n, null, null, 0, e, o);

const To = Po;

const Ao = Po;

function E(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Eo(t, n, null, s.children, 0, o);
}

const Mo = t => t.children;

const Io = (t, n) => new uo(Ro, null, null, t.children, 0, n);

const qo = t => bo(Ro, null, {
    [wr]: ""
}, t.children, 0, t.name ?? "");

const No = Symbol();

const xo = () => null;

const Co = () => null;

const Lo = t => t.children;

const Oo = (t, n) => Po(Io, {
    children: Po(jo, t)
}, n);

const jo = () => null;

let Xo = null;

let Fo = null;

function g(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Fo || (Fo = t.setAttributeNS);
                    Fo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            Xo || (Xo = t.setAttribute);
            Xo.call(t, n, e);
        })(t, n, e);
    }
}

const Do = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Wo = (t, n = [], e = {}) => {
    let s = null;
    const o = t[ms];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[_s];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new uo(null, r, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && Do.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof oo) {
            return va(n, t, ":", e);
        }
    }
    return As(n, "name") || "";
}

class Vo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Uo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class zo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Bo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Ho {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Qo = t => new Vo(t);

const Jo = t => new Uo(t);

const Yo = (t, n) => new zo(t, n);

const Go = (t, n, e) => new Bo(t, n, e);

const Zo = (t, n, e, s = null, o = !1) => new Ho(t, n, e, s, o);

const Ko = () => {
    const t = $a();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Br);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Br, s);
    }
    let o = t.$.getHostProp(e, Hr);
    o === null && (o = 0);
    t.$.setHostProp(e, Hr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const tl = t => {
    const n = nr(t) && !nh(t) ? Ce(void 0, t) : t;
    return Ys(n);
};

const nl = t => el(tl, t);

const el = (t, ...n) => {
    const {val: e, set: s} = Ko();
    if (e != null) {
        return e;
    }
    t = nr(t) && !nh(t) ? wa(t, ...n) : t;
    return s(t);
};

const rl = () => ({
    pending: Ys(0),
    version: Ys(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    let e = null;
    let s = n;
    for (;s && !e; ) {
        e = A(t.container, s);
        s = s.slotParent || s.parent;
    }
    if (!e) {
        return;
    }
    const o = t.boundaries ||= [];
    if (!o.includes(e)) {
        o.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, Lr);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    Nl(t, ti, null);
}

function A(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return ql(t, ti, null) || null;
    }(n) || P(t, n);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && Nl(t, ti, n);
}

function I(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        I(t, o, P(t, o) || e);
    }
}

const il = t => {
    if (t.an) {
        try {
            t.an();
        } catch (t) {
            ze(t);
        }
        t.an = null;
    }
};

function q(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const n = Ae(s);
        return la(n, () => q(t, e, s, ya(e, s, n)));
    }
    const r = o.$;
    const i = o.m;
    Ll(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = ql(i, Qr, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = ql(i, Jr, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return Le(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i, "event"));
}

function N(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Ae(n);
    return la(e, () => {
        const s = ya(t, n, e);
        typeof this === "string" && La(Oa(s.$, this));
        const o = Ca[0];
        return q(o, t, n, s);
    });
}

function x(t) {
    return t.k === t.R ? t.T : null;
}

function C(t) {
    return t.M || x(t);
}

function L(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = x(t);
    return e === o ? null : e;
}

const sl = Object.prototype.hasOwnProperty;

function O(t, n, e, s, o, r) {
    Nl(n, e, r);
    wn(t, Zo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function j(t, n, e, s) {
    return {
        $: t,
        q: n,
        N: e,
        L: s,
        O: [],
        j: [],
        X: [],
        k: null,
        M: null,
        D: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        Z: !0,
        K: !1,
        tt: {
            nt: new lo({
                L: s,
                et: !0
            }),
            rt: new lo({
                L: s,
                et: !1
            })
        }
    };
}

function X(t, n, e, s, o) {
    const r = t ?? j(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.q = e;
        t.N = s;
        t.L = o;
        t.tt.nt.data.L = o;
        t.tt.rt.data.L = o;
        t.j.length = 0;
        t.X.length = 0;
    })(r, n, e, s, o);
    return r;
}

const ol = (t, n, e, s, o, r, i) => F(X(i, t, n, o, r), e, s);

const ll = (t, n, e, s, o, r, i, c, l = !1, u) => F(X(u, t, n, i, c), e, s, o, r, l);

function F(t, n, e, s = lu(e), o = null, r = !1) {
    D(t, n, e, s, o, r);
    const i = G(t);
    if (si(i)) {
        return i.finally(() => {
            Z(t);
        });
    }
    Z(t);
}

function D(t, n, e, s = lu(e), o = null, r = !1) {
    const i = t.K;
    t.K = r || i;
    t.k = e;
    t.D = null;
    t.M = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.O.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    wt(t, t.J);
                } else if (typeof t.J === "number") {
                    wt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (fo(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.J, n);
                            const e = t.J.constProps && sl.call(t.J.constProps, ei) || sl.call(t.J.varProps, ei);
                            e ? t.D || K(t, !1) : U(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Mo) {
                                nt(t);
                                dt(t, "F", t.J.key);
                                U(t, t.J.children, !0);
                            } else if (n === qo) {
                                nt(t);
                                J(t) || U(t, t.J.children, !0);
                            } else if (n === vt) {
                                Q(t);
                                U(t, t.J.children, !0, !0);
                            } else if (n === Co) {
                                tt(t);
                            } else if (n === xo) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        U(t, t.J, !1);
                    } else if (Fu(t.J)) {
                        dt(t, "S", null);
                        const n = t.J instanceof oo ? t.J.it() : t.J;
                        const e = t.M?.[ts]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof oo && (s = qt(e, n));
                        if (!s) {
                            const e = t.D || t.M;
                            U(t, W(t, () => va(n, e, ".", t.$)), !0);
                        }
                    } else if (si(t.J)) {
                        dt(t, "A", null);
                        t.j.push(t.J, t.D || t.M);
                    }
                } else {
                    t.J === No || wt(t, "");
                }
                V(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.K = i;
    }
}

function W(t, e) {
    try {
        return e();
    } catch (s) {
        if (si(s)) {
            const o = s.then(() => n(e));
            t.j.push(o, t.D || t.M);
            return null;
        }
        throw s;
    }
}

function V(t) {
    if (!t.Z) {
        t.Z = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.O.length > 0 && t.O[t.O.length - 1] === !1) {
        return z(t);
    }
    t.D !== null ? t.D = null : t.M = L(t, t.M);
}

function U(t, n, e, s = !1) {
    if (!s && (n == null || e && Ke(n) && n.length === 0)) {
        K(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = !s && t.K || !!t.D || !lu(t.M);
        t.K = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.D || t.M;
        t.M = lu(t.k);
        t.D = null;
    }
    t.Z = !1;
}

function z(t) {
    const n = t.O.pop();
    if (n) {
        t.K = t.O.pop();
        t.B = t.O.pop();
        t.W = t.O.pop();
        t.U = t.O.pop();
        t.D = t.O.pop();
        t.M = t.O.pop();
        t.k = t.O.pop();
    }
    t.J = t.O.pop();
    t.G = t.O.pop();
    t.Y = t.O.pop();
    t.H = t.O.pop();
    V(t);
}

function B(t, n, e) {
    t.O.push(t.H, t.Y, t.G, t.J);
    e && t.O.push(t.k, t.M, t.D, t.U, t.W, t.B, t.K);
    t.O.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function H(t) {
    if (t.D) {
        return C(t);
    }
    return L(t, t.M) || x(t);
}

function Q(t) {
    const n = t.J;
    const e = n.key;
    t.M = ql(t.k, e, n => Fl(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.D = Sl();
        Nl(t.D, $r, e);
        t.D.slotParent = t.k;
        Nl(t.k, e, t.D);
    }
}

function J(t) {
    const n = t.J;
    const e = xu(t.k);
    const s = k(e, n, t.$);
    const o = As(n, Lr) || null;
    const r = e ? ql(e, s, null) : null;
    if (r == null) {
        t.D = Sl();
        Nl(t.D, $r, s);
        Nl(t.D, Lr, o);
        I(t.$, t.D, o);
        e && Nl(e, s, t.D);
        Kl(t.q, t.k, t.D, H(t));
        return !1;
    }
    if (r === t.M) {} else {
        const n = r.parent;
        t.D = r;
        Nl(t.D, $r, s);
        Nl(t.D, Lr, o);
        I(t.$, t.D, o);
        e && Nl(e, s, t.D);
        Zl(t.q, t.D);
        Kl(t.q, t.k, t.D, H(t));
        n && Rl(n) && !n.firstChild && iu(n) === Or && eu(t.q, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            gt(t.$, t.q, e, t.N);
            eu(t.q, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.M = null;
}

function G(t) {
    for (;t.j.length; ) {
        const n = t.j.shift();
        const e = t.j.shift();
        if (si(n)) {
            return n.then(n => {
                D(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        D(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function Z(t) {
    t.q = null;
    t.N = null;
}

function K(t, n = !0) {
    const e = t.M && lu(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            gt(t.$, t.q, s, t.N);
            s = s.nextSibling;
        }
        ru(t.q, t.M, e, n);
    }
}

function tt(t) {
    const n = x(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = L(t, t.M);
            if (t.k === n.parent) {
                gt(t.$, t.q, n, t.N);
                eu(t.q, t.k, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.M !== null && Al(t.M)) {
        const n = t.M;
        t.M = L(t, t.M);
        eu(t.q, t.k, n, !0);
    }
}

function et(t, n, e) {
    if (Fu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw er(15, [ e ]);
}

function rt(t, e, s, o, r) {
    return n(() => va(o, e, s, t, r));
}

function it(t, n, e, s, o) {
    const i = t.L;
    const c = s.then(t => g(n, e, r(e, t, i), o));
    t.X.push(c);
}

function st(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(xr, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, s) {
    const i = function c(t, n) {
        const e = nu(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.D = bl(i, n);
        t.D.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.D;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (hi(n)) {
                ut(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && et(o, i, s)) {
                continue;
            }
            Fu(o) && (o = rt(t.$, t.D, n, o, t.tt.nt));
            if (si(o)) {
                it(t, i, n, o, u);
                continue;
            }
            if (n === ei) {
                st(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(i, o)) {
                continue;
            }
            g(i, n, r(n, o, t.L), u);
        }
    }
    const a = n.key;
    a && (t.D.key = a);
    if (t.L) {
        const e = sl.call(n.varProps, "class") || n.constProps && sl.call(n.constProps, "class");
        e || i.setAttribute("class", t.L);
    }
    Hl(t.q, t.k, t.D, C(t));
}

function ut(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(q.bind(null, n));
                }
            } else {
                e && s.push(q.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = q.bind(null, n));
    }
    t.charAt(2) !== "e" && xl(o.q, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ct(t, n, e) {
    if (t.K) {
        lt(t, n, e, null);
    } else {
        const s = t.M && Rl(t.M);
        const o = s && e === iu(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            at(t, e, r);
        } else {
            const s = ft(e, r);
            ht(t, e, r, s, t.k) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.D || t.M;
    s && function r(t, n, e, s) {
        t.K || Ll(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !sl.call(o, i) ? i.toLowerCase() : i;
            if (o && sl.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    Nl(n, l, null);
                    Nl(n, i, e);
                }
                Pt(c, e) || ul(t, n, i, c, s);
            } else {
                c != null && ul(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                sl.call(e, r) || r.charAt(0) === ":" || hi(r) || ul(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const ul = (t, n, e, s, o) => {
    if (hi(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === Qr || e === Jr) {
        Nl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const i = n[ts]?.get(e);
    if (Fu(s)) {
        const o = s instanceof oo ? s.it() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Rn(t.$, i);
        const r = n;
        s = rt(t.$, r, e, o, t.tt.rt);
    } else {
        i && Rn(t.$, i);
    }
    if (si(s)) {
        const o = n;
        const i = s.then(n => {
            O(t.q, o, e, n, t.L, r);
        });
        t.X.push(i);
        return;
    }
    O(t.q, n, e, s, t.L, r);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, r) {
    t.D = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.M;
            if (o) {
                const s = Rl(o) ? iu(o) : null;
                const r = mt(o) || _t(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = x(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = Rl(i) ? iu(i) : null;
                const r = mt(i) || _t(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(ft(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = Rl(t.M) ? iu(t.M) : null;
                    const e = mt(t.M) || _t(t.M, t.$._);
                    if (e != null) {
                        const s = ft(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.M);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = x(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = Rl(s) ? iu(s) : null;
                const e = mt(s) || _t(s, t.$._);
                if (e != null) {
                    const o = ft(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.D) {
        s || Kl(t.q, o, t.D, C(t));
        t.M = t.D;
        t.D = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.M) {
                const n = mt(t.M) || _t(t.M, t.$._);
                if (n != null) {
                    const e = Rl(t.M) ? iu(t.M) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.M);
                    }
                }
            }
            n !== t.M && Kl(t.q, o, n, C(t));
            t.M = n;
            t.D = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = mt(t.M);
    const r = t.M && Ml(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        at(t, null, o);
        return;
    }
    if (e === null || t.K) {
        Ql(t.q, t.k, t.D = Sl(), H(t));
        t.D.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.k, !0)) {
        Ql(t.q, t.k, t.D = Sl(), H(t));
        t.D.key = e;
    }
}

function pt(t, n) {
    const e = n[th];
    let s = t.D || t.M;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.st;
        const l = _t(s, t.$._);
        const u = o.key || c;
        const f = mt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.D;
                r = !0;
            }
        } else {
            if (ht(t, null, u, u, t.k)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.D || t.M;
        }
        if (s) {
            const e = ql(s, zr, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = bt(n[ms], e[ms], e[bs], s, !1);
                        o ||= t;
                        const r = bt(n[_s], e[_s], e[bs], s, !0);
                        o ||= r;
                        e[vs] = n[vs];
                    } else if (n) {
                        Nl(t, zr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.D;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                Nl(s, hr, i);
                s.flags &= -33;
                yn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new uo(vt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            Qe(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (fo(n) && As(n, $r) || "") + "";
                const i = He(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            U(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = mt(s);
        const i = e === r;
        const c = _t(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.D;
        } else if (i) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.k) && yt(t);
            s = t.D || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!Ml(e) || ql(e, hr, null) === null); ) {
                e = e.parent || xu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[ws] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            yn(t.$, s, 8, t.N);
        }
    }
}

function $t(t, n, e, s) {
    n && kn(t.$, n);
    Ql(t.q, t.k, t.D = Sl(), H(t));
    const o = t.J;
    Nl(t.D, hr, e);
    Nl(t.D, zr, s);
    t.D.key = o.key;
}

function yt(t) {
    Ql(t.q, t.k, t.D = Sl(), H(t));
    const n = t.J;
    Nl(t.D, zr, n.props);
    n.key && (t.D.key = n.key);
}

function wt(t, n) {
    if (t.M !== null) {
        const e = qu(t.M);
        if (e === 3) {
            if (n !== su(t.M)) {
                ou(t.q, t.M, n);
                return;
            }
            return;
        }
    }
    Hl(t.q, t.k, t.D = gl(document.createTextNode(n), n), C(t));
}

function mt(t) {
    if (t == null || Al(t)) {
        return null;
    }
    return t.key;
}

function _t(t, n) {
    if (t == null || Al(t)) {
        return null;
    }
    const e = ql(t, hr, n);
    return e ? e.st : null;
}

function vt() {}

function bt(t, n, e, s, o = !0) {
    if (Et(t) && Et(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Pr) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (!n || !Pt(i, c) && !Tt(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && At(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = Ts(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Pr) {
                continue;
            }
            if ((!t || !sl.call(t, s)) && o) {
                delete n[s];
                const t = Ts(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function Et(t) {
    if (!t) {
        return !0;
    }
    return zi(t);
}

function gt(t, n, e, s = null) {
    let o = e;
    const r = s && dn(s) ? y(s) : null;
    if (Al(e)) {
        Rt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && dn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            kn(t, o);
            Rt(o);
            const r = c & 2 && ql(o, hr, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Br);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Ze(r)) {
                            const n = ju(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                yn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof Ws || r instanceof oo) && (r.h & 4 || kn(t, r));
                            (n || r instanceof Ws && (r.h & 512 || r.ot)) && il(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Fl(t.rootVNode, e) : e;
                                let c = lu(o);
                                for (;c; ) {
                                    gt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = Il(o);
            if (i) {
                if (o === e) {
                    const n = lu(o);
                    if (n) {
                        vn(n);
                        return;
                    }
                    St(t, o);
                }
            } else {
                const t = lu(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function St(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, $r);
    e != null && t.getHostProp(n.slotParent, e) === n && Nl(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && iu(s) === Or) {
            St(t, e);
            eu(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof oo && n instanceof oo && It(n, t);
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    if (Fu(t) && Fu(n)) {
        const e = t instanceof oo ? t.it() : t;
        const s = n instanceof oo ? n.it() : n;
        return wa(() => e.value === s.value);
    }
    return !1;
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return vi(t) === vi(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return mi(t) === mi(n);
}

function It(t, n) {
    if (t === n) {
        return !0;
    }
    return n.lt === t.lt && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ut, t.ut);
}

function qt(t, n) {
    if (!(n instanceof oo)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof oo && It(s, n)) {
            return !0;
        }
    }
    return !1;
}

const cl = (t, n, e, s, o) => {
    const r = Oe(t.sn, n, t);
    if (e) {
        r.un = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, hr));
    if (ir(s)) {
        o = o || t.getHostProp(n, zr) || ks;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (nh(s)) {
        const t = s;
        i = () => Le(r, t, [ o || ks, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => Le(r, t, [ o || ks ]);
    }
    const l = De;
    const u = (e = 0) => oi(() => {
        if (!c) {
            t.setHostProp(n, Hr, null);
            t.setHostProp(n, Zr, null);
        }
        e > 0 && kl(n) && kn(t, n);
        return li(i(o), t => li(r.cn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < ii) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Gr);
        if (o) {
            return function r(t, n, e) {
                const s = Lt(n);
                let o = n;
                const r = "q-e:qvisible";
                return li(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = jt();
                                    const n = De;
                                    n && t.ct(i) || (o = Ot(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                xt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (si(t) && e < ii) {
            return t.then(() => u(++e));
        }
        if (e >= ii) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function xt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = $i(n);
    c && Ct(t, f, "capture");
    l && Ct(t, f, "preventdefault");
    u && Ct(t, f, "stoppropagation");
}

function Ct(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === ks && (t.varProps = {});
    t.varProps[s] = !0;
}

function Lt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (fo(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Ke(t)) {
            n.push(...t);
        } else {
            if (si(t)) {
                return li(t, t => Lt(t));
            }
            if (Fu(t)) {
                return Lt(t.untrackedValue);
            }
        }
    }
    return null;
}

function Ot(t, n) {
    if (fo(t)) {
        if (t.type !== Mo && !nh(t.type)) {
            return bo(Mo, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : Ke(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return bo(Mo, null, null, [ t, n ], 0, null);
    }
    if (Ke(t) && t.length > 0) {
        Ot(t[0], n);
        return t;
    }
    return t;
}

function jt() {
    return new uo("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Xt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Ft(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Xt(t[c], c, r, s);
    }
    return i;
}

function Dt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Wt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = lu(e);
    const f = j(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return ll(c, n, Ft(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        ru(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return ll(c, n, Ft(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        ru(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            eu(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return ll(c, n, Ft(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const _ = d - h + 1;
    const m = new Map;
    for (let t = h; t <= d; t++) {
        m.set(a[t], t - h);
    }
    const b = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const E = [];
    const g = new Map;
    for (let t = 0; t < b.length; t++) {
        const s = b[t];
        const o = s.key;
        if (m.has(o)) {
            g.set(o, E.length);
            E.push(s);
        } else {
            eu(n, e, s, !0);
        }
    }
    const S = new Int32Array(_);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < _; t++) {
        const n = g.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(_);
    const T = function M(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let I = d;
    let A = w;
    const q = () => {
        for (;I >= h; ) {
            const t = I - h;
            if (P[t] === 1) {
                A = E[S[t]];
                I--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = E[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Kl(n, e, t, A);
                A = t;
                I--;
                continue;
            }
            let l = I;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = I - l + 1;
            const d = ll(c, n, Ft(o, a, null, i, l, I), e, A, A, s, null, !0, f);
            return li(d, () => {
                const t = Dt(e, A, u);
                A = t;
                I = l - 1;
                return q();
            });
        }
    };
    return q();
}

function Vt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Br);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Ou) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Lu(s, n, t);
                si(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ut(t, n) {
    const e = t.props ||= {};
    e[ps] = n;
}

function zt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[$s] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[$s] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = zl(n, document, r, e);
    const u = Rl(r) && i || r;
    const f = u === r ? null : c;
    Hl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Bt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[ps];
    }(t);
    if (!r) {
        return;
    }
    Ut(t, null);
    Fu(r) && (r = r.value);
    return ol(n, e, r, o, s, null);
}

function Ht(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, hr);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, zr) || null;
    return Jt(n, o, o, r, i, e, s);
}

function Qt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[ws] || null;
        e && delete n[ws];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Jt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Jt(t, e, s, o, r, i, c) {
    const l = oi(() => cl(t, e, s, o, r), s => {
        const o = t.getHostProp(e, kr);
        return n(() => ol(t, i, s, e, c, ai(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (si(l)) {
        return l;
    }
    return;
}

function Yt(t, n, e, s, o, r = null) {
    n.push(Zo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Gt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[ds] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Fu(e) && (e = e.value);
        const r = s.isConst;
        Yt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[ds];
    })(t);
}

function Zt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Br);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Ou && n.h & 16) {
            n.h &= -17;
            const t = n;
            il(t);
        }
    }
}

function Kt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, ys);
    if (!s) {
        return;
    }
    const o = s.ft;
    const r = je();
    r.$ = e;
    return li(n(() => Ce.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return zu(e, s, o);
        }
    });
}

function tn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, zr) || null;
    if (!r) {
        return;
    }
    let i = Ms(r, "items");
    Fu(i) && (i = wa(i));
    const c = Ms(r, "key$");
    const l = Ms(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Wt(n, e, o, s, i, u, f);
    }
    return li(c.resolve(), t => li(l.resolve(), r => Wt(n, e, o, s, i, t, r)));
}

let fl = null;

const al = (t, n, e) => {
    fl || (fl = t.insertBefore);
    fl.call(t, n, e);
};

function nn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                al(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                al(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof Bo) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            al(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof Vo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof Uo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof zo) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Ho) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (hl(t, e)) {
                t[e] = dl(o);
            } else if (e === ei) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(xr, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : g(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const hl = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const dl = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const pl = (t => () => queueMicrotask(t))(sn);

const yl = Ei(sn);

let wl = !1;

function en() {
    if (!wl) {
        wl = !0;
        pl();
    }
}

function rn() {
    if (!wl) {
        wl = !0;
        yl();
    }
}

function sn() {
    wl = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (on(e, n)) {
            rn();
            return;
        }
    }
}

function on(t, n) {
    const e = De;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        ln(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(r, s, fn(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Zt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, fn(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Vt(l, r, s);
            } else if (l.dirty & 2) {
                e = Bt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Qt(l, r, i, t);
            } else if (l.dirty & 256) {
                e = tn(l, r, i, t);
            } else if (l.dirty & 16) {
                Gt(l, i);
            } else if (l.dirty & 32) {
                e = Kt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && zt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && si(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                en();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    ln(r, t, s, e);
}

function ln(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                nn(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    Lu(s, t, s.ht);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                un(t);
            });
            return;
        }
        un(t);
    }
}

function un(t) {
    t.dt();
}

function cn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = fn(o[0], s, t);
    p(t, n, i);
    return i;
}

function fn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && an(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return fn(s, n, e);
}

function an(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(Lr in n.props) || !t.getHostProp(n, Lr)) {
        return !1;
    }
    dn(n) || hn(t, n, 0);
    return !0;
}

function hn(t, n, e) {
    if (dn(n)) {
        en();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        hs.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    en();
    return r;
}

function dn(t) {
    return (t.flags & 256) !== 0;
}

function pn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(ds);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Fu(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 32 && Kt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Br);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Ou) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Lu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        si(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, zr) || null;
            if (!s) {
                return;
            }
            let o = Ms(s, "items");
            Fu(o) && (o = wa(o));
            const r = await Ms(s, "key$").resolve();
            const i = await Ms(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const ml = [];

function $n(t) {
    for (let n = 0; n < ml.length; n++) {
        const e = ml[n];
        const s = ml[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function yn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return De;
    }()) {
        const e = pn(t, n);
        si(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            ml.push(n);
            let o = P(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 1023;
                const i = dn(r);
                __EXPERIMENTAL__.suspense && (o ||= P(t, r) || (e ? A(t, r) : null));
                if (r === s || e) {
                    M(n, o);
                    $n(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    ml.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                ml.push(r);
                r = r.slotParent || r.parent;
            }
            ml.length = 0;
            ((t, ...n) => {
                const e = Be(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, P(t, n) || A(t, c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (dn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        dn(n) ? M(n, P(t, n)) : function l(t, n) {
            ml.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = dn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? A(t, s) : null));
                if (o) {
                    M(n, e);
                    $n(s);
                    ml.length = 0;
                    return !0;
                }
                ml.push(s);
                s = s.slotParent || s.parent;
            }
            M(n, e);
            ml.length = 0;
            return !1;
        }(t, n) || hn(t, n, 0);
    }
}

function wn(t, n) {
    t.push(n);
}

const _l = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const vl = t => {
    let n = null;
    return e => {
        n || (n = _l(e, t));
        return n.call(e);
    };
};

const bl = (t, n, e = null) => {
    const s = new us(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const El = t => {
    const n = new us(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const gl = (t, n) => {
    const e = new cs(-4084, null, null, null, null, t, n);
    return e;
};

const Sl = () => {
    const t = new ls(null, -4094, null, null, null, null, null, null);
    return t;
};

const kl = t => t instanceof os;

const Rl = t => (t.flags & 1) === 1;

const Pl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const Tl = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Al = t => (t.flags & 4) === 4;

const Ml = t => (t.flags & 2) === 2;

const Il = t => {
    const n = t.flags;
    return (n & 2) === 2 && ql(t, $r, null) !== null;
};

const Hd = t => t;

const ql = (t, n, e) => {
    if (Rl(t) || Ml(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const Nl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const xl = (t, n, e, s, o = null) => {
    if (Rl(n)) {
        Nl(n, e, s);
        wn(t, Zo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Cl = t => {
    if (t.key) {
        return;
    }
    const n = hu(t.node, ni);
    n && (t.key = n);
};

const Ll = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (hi(c)) {
                mn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== ni && c) {
                if (c.startsWith(xr)) {
                    const t = i.value;
                    t === "html" ? Nl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && Nl(e, "value", s.value);
                } else {
                    const t = i.value;
                    Nl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        ql(e, Qr, null) === null && ql(e, Jr, null) === null || (n.flags |= 64);
    }
};

const Ol = t => {
    if (t.bt === "_run") {
        const n = t.getCaptured()?.[0];
        if (ir(n)) {
            return n;
        }
    }
    return t;
};

function mn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Ol(jn(i[t], e));
        c.push(q.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function _n(t, n, e) {
    let s = lu(n);
    for (;s; ) {
        if (Al(s)) {
            Xl(t, s);
            e(s, n);
        } else {
            Rl(s) ? e(s, n) : _n(t, s, e);
        }
        s = s.nextSibling;
    }
}

function vn(t) {
    let n = t;
    if (Al(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = lu(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const jl = (t, n, e) => {
    let s = t;
    for (;e && s && Ml(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !Ml(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !Ml(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Al(t) && e && Rl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && Tu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Xl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = tu(n, !0);
        const o = e.node;
        const r = Eu(s);
        let i = jl(n, !1, !0);
        const c = jl(n, !0, !0);
        const l = o || (c && Rl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Al(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                wn(t, Go(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = jl(i, !1, !0);
        }
        i = n;
        for (;i && Al(i); ) {
            const n = jl(i, !0, !0);
            const e = !n || !Al(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    wn(t, Yo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    wn(t, Go(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Fl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = El(i);
            Cl(e);
            t.vNode = e;
            return e;
        }
    }
    if (kl(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || El(i);
            Cl(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = Vl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Ul(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = Dl(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const Dl = (t, n) => {
    let e = lu(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Wl = [];

const Vl = (t, n) => {
    let e = lu(t);
    for (;e && (!(e instanceof us) || e.node !== n); ) {
        if (Ml(e)) {
            const t = e.nextSibling;
            const n = lu(e);
            if (n) {
                t && Wl.push(t);
                e = n;
            } else {
                e = t || (Wl.length ? Wl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Wl.pop();
        }
    }
    for (;Wl.length; ) {
        Wl.pop();
    }
    return e;
};

const Ul = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const zl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = bl(o, "errored-host");
    if (Pl(e)) {
        Kl(t, r, e, null);
    } else {
        const n = [];
        _n(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Kl(t, r, n[e], null);
        }
    }
    return r;
};

const Bl = nn;

const Hl = (t, n, e, s) => {
    const o = Rl(n);
    o && uu(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Gl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : tu(n, !1);
    l && !c && wn(t, Go(i, l, Jl(t, n, s)?.node ?? null));
    Yl(n, e, s);
    c && (e.flags |= 32);
};

const Ql = (t, n, e, r) => {
    const i = Rl(n);
    i && uu(n);
    const c = e.parent;
    if (e === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Gl(t, c, n, e);
    const l = n.flags & 32;
    const u = !i && n.flags & 2048 ? n.props?.[dr] : null;
    const f = u ? null : i ? n : nu(n, !1);
    const a = u || f?.node;
    const h = Jl(t, n, r);
    const d = h?.node ?? null;
    const p = Il(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = nu(n, !1);
        const c = Jl(t, n, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(i, e);
        _n(t, e, n => {
            if (Al(n)) {
                wn(t, Go(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Rl(c)) {
                                e = c.node;
                                const t = iu(c);
                                const l = c.parent;
                                const h = u == null ? n : l && nu(l, !0);
                                if (h) {
                                    const t = o(h, iu(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = lu(c);
                                a = s(e, t, r, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (fu(e)) {
                                    const t = Me(e);
                                    if (t) {
                                        const n = lu(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, i, l, u);
                    t && (n.node = t);
                }
                wn(t, Go(n.node, a, c));
            }
        });
    } else {
        a && !l && _n(t, e, n => {
            wn(t, Go(n.node, a, d));
        });
    }
    Yl(n, e, r);
    l && (e.flags |= 32);
};

const Jl = (t, n, e) => {
    let s = null;
    e == null ? Ml(n) && (s = jl(n, !0, !1)) : s = Ml(e) ? jl(e, !0, !0) : e;
    s && Al(s) && Xl(t, s);
    return s;
};

const Yl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Gl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && eu(t, n, s, !1);
};

const Zl = (t, n) => {
    let e = n;
    for (;e && Ml(e); ) {
        e = e.lastChild;
    }
    e && Al(e) && (e.flags & 8) === 0 && Xl(t, e);
};

const Kl = (t, n, e, s) => {
    Pl(e) ? Hl(t, n, e, s) : Ql(t, n, e, s);
};

const tu = (t, n) => {
    for (;t && !Rl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[dr];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const nu = (t, n) => {
    for (;t && !Rl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const eu = (t, n, e, s) => {
    Al(e) && Xl(t, e);
    if (s) {
        const s = ql(n, ei, null) !== null;
        if (s) {
            return;
        }
        Pl(e) ? wn(t, Qo(e.node)) : _n(t, e, n => {
            wn(t, Qo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const ru = (t, n, e, s = !0) => {
    const o = tu(n, !0);
    if (o && s) {
        if (Pl(n)) {
            wn(t, Jo(n.node));
        } else {
            const e = nu(n, !1);
            e && e.firstChild === n && e.lastChild === n ? wn(t, Jo(o)) : _n(t, n, n => {
                wn(t, Qo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const iu = t => {
    const n = Hd(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = bu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = vu(t);
            switch (n) {
              case Fr:
                return 512;

              case Dr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const su = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const ou = (t, n, e) => {
    Xl(t, n);
    n.text = e;
    wn(t, Yo(n.node, e));
};

const lu = t => {
    if (Al(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && Rl(t) && function e(t) {
        const n = t.getAttribute(vr);
        if (n === null) {
            return !1;
        }
        const e = _u(t);
        return Nu(e) && e.localName === "template" && e.getAttribute(_r) === n && yu(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = uu(t));
    return n;
};

const uu = n => {
    const e = Hd(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && fu(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = _u(e);
            const o = Eu(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                Cl(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === cr && o.charCodeAt(1) === cr) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = gu(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = Nu(t);
                            return !n || n && Sn(t);
                        };
                        let p = null;
                        Su(e, ($, y, w, _, m, b) => {
                            if (Au($())) {
                                for (;d(o); ) {
                                    o = yu(o);
                                    if (!o) {
                                        throw er(27, [ e, $(), m ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Au($()); ) {
                                    t *= 10;
                                    t += w() - 48;
                                }
                                for (;t--; ) {
                                    const n = El(o);
                                    Cl(n);
                                    u(n);
                                    o = yu(o);
                                    for (;Nu(o) && Sn(o); ) {
                                        o = yu(o);
                                        if (!o && t > 0) {
                                            throw er(27, [ e, $(), m ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                Nl(n, kr, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                Nl(n, hr, y());
                            } else if ($() === 61) {
                                h || (h = Ae(s));
                                const t = y();
                                h.Jn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                Nl(n, zr, y());
                            } else if ($() === 64) {
                                n.key = b();
                            } else if ($() === 91) {
                                Nl(n, Br, y());
                            } else if ($() === 94) {
                                Nl(n, Hr, y());
                            } else if ($() === 96) {
                                h || (h = Ae(s));
                                En(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = Ae(s));
                                n.slotParent = Fl(h.rootVNode, y());
                            } else if ($() === 93) {
                                Nl(n, Rr, y());
                            } else if ($() === 123) {
                                w();
                                u(Sl());
                                Iu.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === cr) {
                                const e = y();
                                const s = decodeURIComponent(t(e));
                                const o = m + e.length + 1;
                                const r = _(o + 1) === cr;
                                let i;
                                if (r) {
                                    w();
                                    i = decodeURI(t(y()));
                                    w();
                                } else {
                                    i = t(y());
                                }
                                Nl(n, s, i);
                            } else if ($() === 125) {
                                w();
                                n.lastChild = c;
                                r = Iu.pop();
                                l = Iu.pop();
                                c = Iu.pop();
                                i = Iu.pop();
                                n = Iu.pop();
                            } else if ($() === 126) {
                                Nl(n, $r, b());
                            } else {
                                for (;Nu(o) && Sn(o); ) {
                                    o = yu(o);
                                }
                                const t = o && du(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Mu($()); ) {
                                    n += w() - 97;
                                    n *= 26;
                                }
                                n += w() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new cs(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Ae(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return gu(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let cu = null;

const fu = t => {
    cu || (cu = t.hasAttribute);
    return cu.call(t, xr);
};

let au = null;

const hu = (t, n) => {
    au || (au = t.getAttribute);
    return au.call(t, n);
};

const du = vl("nodeType");

const pu = t => {
    const n = du(t);
    return n === 3 || n === 1;
};

let $u = null;

const yu = t => {
    $u || ($u = _l(t, "nextSibling"));
    mu || (mu = _l(t, "firstChild"));
    for (;t; ) {
        t = $u.call(t);
        if (t !== null) {
            const n = du(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(qr)) {
                    return bn(t, Mr, $u, mu);
                }
                if (t.nodeValue?.startsWith(Ir)) {
                    return bn(t, [ Mr, Nr ], $u, mu);
                }
                if (n?.startsWith(xr)) {
                    for (;t && (t = $u.call(t)) && (du(t) !== 8 || !t.nodeValue?.startsWith(Cr)); ) {}
                }
            }
        }
    }
    return t;
};

function bn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = wu(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const wu = vl("parentNode");

let mu = null;

const _u = t => {
    mu || (mu = _l(t, "firstChild"));
    t = t && mu.call(t);
    if (t && du(t) === 8) {
        $u || ($u = _l(t, "nextSibling"));
        if (t.nodeValue?.startsWith(qr)) {
            return bn(t, Mr, $u, mu);
        }
    }
    for (;t && !pu(t); ) {
        t = yu(t);
    }
    return t;
};

const vu = vl("namespaceURI");

const bu = vl("nodeName");

const Eu = vl("ownerDocument");

const gu = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;Nu(i) && Sn(i); ) {
            i = yu(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = du(i);
        let e = null;
        if (n === 3) {
            e = gl(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = El(i);
            Cl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = yu(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Su(e, (e, s) => {
            if (e() === 61) {
                n || (n = Ae(t.node));
                const e = s();
                n.Jn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Ae(t.node));
                En(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function En(t, n, e) {
    if (t[ts]) {
        const s = t[ts];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, ts, {
            get() {
                const s = e._(n);
                t[ts] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, ts, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Su = (n, e) => {
    let s = 0;
    let o = 0;
    let r = 0;
    const i = t => t < n.length ? n.charCodeAt(t) : 0;
    const c = () => r !== 0 ? r : r = i(s);
    const l = () => {
        o = c();
        r = 0;
        s++;
        return o;
    };
    const u = () => {
        l();
        const t = s;
        for (;c() <= 58 && r !== 0 || r === 92 || r === 95 || r >= 65 && r <= 90 || r >= 97 && r <= 122; ) {
            l();
        }
        return n.substring(t, s);
    };
    const f = () => {
        if (i(s + 1) !== cr) {
            return u();
        }
        l();
        const n = decodeURIComponent(t(u()));
        l();
        return n;
    };
    for (;c() !== 0; ) {
        e(c, u, l, i, s, f);
    }
};

const ku = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Ll(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(ni) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Ru = (t, n) => {
    let e = Pu(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Pu(e);
    }
    return !1;
};

const Pu = t => t.parent || t.slotParent;

const Tu = t => {
    if (t === null || Ml(t)) {
        return null;
    }
    return t.node;
};

function gn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Rl(e)) {
                        const t = Ie(e.node);
                        if (!t) {
                            return null;
                        }
                        return Me(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Al(i)) {
            c.push(In(su(i)));
        } else if (Ml(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = ku(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== sr && e !== "__scopedStyleIdPrefix__") {
                        const t = ql(i, e, null);
                        s.push(" " + e + "=" + In(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (or[ql(i, sr, null) || "V"] || or.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = lu(i);
            u && c.push("  " + gn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Rl(i)) {
            const s = iu(i);
            const l = [];
            dn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? ku(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = ql(i, n, null);
                l.push(" " + n + "=" + In(e));
            }
            const f = Tu(i);
            if (f) {
                const t = Eu(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + In(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + In(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (Tl(i) || e) {
                const e = lu(i);
                e && c.push("  " + gn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Au = t => 48 <= t && t <= 57;

const Mu = t => 97 <= t && t <= 122;

function Sn(t) {
    return !t.hasAttribute(ni) || t.nodeName === "STYLE" && (t.hasAttribute(kr) || t.hasAttribute(Er));
}

const Iu = [];

const qu = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw er(26, [ n ]);
};

const Nu = t => t && typeof t == "object" && du(t) === 1;

const xu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!Ml(t) || ql(t, hr, null) === null); ) {
            const e = t.slotParent;
            const s = Ml(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function kn(t, n) {
    kl(n) && Rl(n) && uu(n);
    const e = n[ts];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Rn(t, n);
    }
    e.clear();
}

function Rn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Fs) {
            Pn(t, s, n);
            s instanceof Ws && Tn(s, n);
        } else if (Ns(s)) {
            const t = s[bs];
            An(t, n);
        } else if (t.$t.has(s)) {
            const e = t.$t.get(s);
            const o = Gu(e);
            An(o, n);
        }
    }
    e.clear();
}

function Pn(t, n, e) {
    const s = n.ft;
    s && s.has(e) && s.delete(e);
    if (n instanceof oo && !s?.size) {
        n.m = void 0;
        kn(t, n);
    }
}

function Tn(t, n) {
    const e = t.yt;
    e && e.has(n) && e.delete(n);
    const s = t.wt;
    s && s.has(n) && s.delete(n);
    t._t();
}

function An(t, n) {
    const e = t?.ft;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Cu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Ko();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Ou(6 | i, r, o.m, t, null);
    s(c);
    const l = o.$;
    const {cn: u} = o;
    const f = li(u, () => Lu(c, l, o.m));
    si(f) && (o.cn = f);
};

const Lu = (t, n, e) => {
    const s = t.Yn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => {
        Gf(t, "task");
        n.handleError(t, e, "task");
    };
    let r = null;
    const i = li(((t, n) => {
        const e = t.Gn;
        if (e) {
            return e;
        }
        const s = t.an;
        if (!s) {
            return;
        }
        t.an = null;
        try {
            const e = s();
            if (si(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Gn === s && (t.Gn = void 0);
                });
                t.Gn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = je(n.sn, e, "qTask");
        s.$ = n;
        const i = t.vt.getFn(s, () => kn(n, t));
        const c = Xs(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.an = () => {
                            t.an = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    si(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return oi(() => i(u), l, s => {
            if (si(s)) {
                return s.then(() => {
                    t.Yn === r && (t.Yn = null);
                    return Lu(t, n, e);
                });
            }
            o(s);
        });
    });
    if (si(i)) {
        r = i.finally(() => {
            t.Yn === r && (t.Yn = null);
        });
        t.Yn = r;
        return r;
    }
    return i;
};

class Ou extends ns {
    h;
    Lt;
    ht;
    vt;
    an;
    Gn;
    Yn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Lt = n;
        this.ht = e;
        this.vt = s;
        this.an = o;
    }
}

const ju = t => t instanceof Ou;

function Mn(t, n) {
    const e = Ae(n);
    return la(e, () => {
        typeof this === "string" && La(Oa(e, this));
        const t = Ca[0];
        t.h |= 4;
        yn(e, t.ht, 1);
    });
}

const Xu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Fu = t => t instanceof Fs;

const Du = (t, n) => {
    t.add(n);
};

const Wu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Vu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        ju(e) ? o = e.vt : e instanceof Ws ? o = e.jt : s === ":" && (o = n.getHostProp(e, hr));
        o && n.serializationCtx.Ct.add(o);
    }
};

const Uu = (t, n) => {
    if (t && (!n || t === n || Ki(t))) {
        return t;
    }
    return n;
};

const zu = (t, n, e) => {
    const s = We;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (ju(o)) {
                o.h |= 4;
                yn(t, o.ht, 1);
            } else if (o instanceof Fs) {
                o.invalidate();
            } else if (r === ":") {
                yn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ut(o, n);
                    yn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof lo) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.L,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[ds];
                            if (!o) {
                                o = new Map;
                                s[ds] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(ds);
                        if (!n) {
                            n = new Map;
                            t.setProp(ds, n);
                        }
                        n.set(r, c);
                    }
                    yn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Bu = t => Ze(t) && typeof t[Lf] === "function";

const Hu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Qu = t => {
    t.h |= 4;
};

const Ju = [];

function In(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (ju(t)) {
            return `Task(${In(t.vt)})`;
        }
        if (ir(t)) {
            return `Qrl(${t.bt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Ju.includes(t)) {
                return "*";
            }
            Ju.length;
            try {
                Ju.push(t);
                if (Array.isArray(t)) {
                    return kl(t) ? "(" + (ql(t, sr, null) || "vnode") + ")" : t.map(In);
                }
                if (Fu(t)) {
                    return t instanceof oo ? "WrappedSignal" : t instanceof Ws ? "ComputedSignal" : "Signal";
                }
                if (ec(t)) {
                    return "Store";
                }
                if (fo(t)) {
                    return Yu(t);
                }
                if (kl(t)) {
                    return "(" + (ql(t, sr, null) || "vnode") + ")";
                }
            } finally {
                Ju.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Yu = t => {
    if (fo(t)) {
        if (typeof t.type === "function") {
            const n = t.type[th];
            if (n) {
                const [t] = n;
                return "Component(" + t.bt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + In(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Yu(e);
                    }
                } else {
                    n += Yu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Gu = t => t[Os];

const Zu = t => {
    try {
        return t?.[Ls] || null;
    } catch {
        return null;
    }
};

const Ku = (t, n) => {
    const e = Gu(t);
    e && e.force(n);
};

const tc = (t, n) => {
    const e = Gu(t);
    if (e) {
        return (e.ft?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const nc = t => Zu(t) || t;

const ec = t => Ls in t;

function qn(t, n, e) {
    return new Proxy(n, new ic(e, t || null));
}

const rc = (t, n, e) => {
    if (Ge(t) && e) {
        let s = e.$t.get(t);
        if (!s) {
            s = qn(e, t, n);
            e.$t.set(t, s);
        }
        return s;
    }
    return t;
};

class ic {
    h;
    $;
    ft=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Zu(this);
        zu(this.$, this, Cn(n, t, this.ft));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Ls) {
                return t;
            }
            if (n === Os) {
                return this;
            }
            return t[n];
        }
        const e = da();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.un;
            o && Nn(t, Array.isArray(t) ? js : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        let r = !1;
        if (o & 1 && Ze(s)) {
            try {
                r = !Object.isFrozen(s) && !ec(s) && !Object.isFrozen(t);
            } catch {}
        }
        if (r) {
            return rc(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? nc(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && xn(n, s, t, this);
        } else {
            xn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || zu(this.$, this, Cn(t, n, this.ft));
        return !0;
    }
    has(t, n) {
        if (n === Ls) {
            return !0;
        }
        if (typeof n === "string") {
            const e = da();
            if (e) {
                const s = e.un;
                s && Nn(t, Array.isArray(t) ? js : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = da();
        const e = n?.un;
        e && Nn(t, js, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Nn(t, n, e, s, o) {
    const r = e.ft ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = De;
    const l = __EXPERIMENTAL__.suspense && e instanceof ic && c;
    Du(i, s);
    Wu(s, t);
    if (c) {
        const i = Uu(o, e.$);
        l && i?.Sn?.(t, s, n, r);
        Vu(s, i);
    }
}

function xn(t, n, e, s) {
    e[t] = n;
    const o = Cn(e, t, s.ft);
    o && zu(s.$, s, o);
}

function Cn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(js);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

class sc extends Error {
    data;
    constructor(t) {
        super(typeof t === "string" ? t : typeof t?.message === "string" ? t.message : "Server error");
        this.data = t;
    }
}

const oc = "q:pe";

const lc = t => {
    try {
        return t instanceof sc;
    } catch {
        return !1;
    }
};

const uc = Symbol();

const cc = [ void 0, null, !0, !1, "", Ss, ks, xs, js, gs, qo, Mo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const fc = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const ac = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function Ln(t, n, e) {
    let s = n.bt;
    let o = n.Et;
    const r = Pi();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => ir(t) && t.bt == rr)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t.St(n.st));
        if (!o) {
            throw er(14, [ n.bt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.kt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function On(t, n, e, s) {
    return Da(t, n, null, null, e, s);
}

function jn(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return On(o, r, i, n);
}

class hc {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class dc {
    Zn;
    Kn=0;
    Pt=[];
    te=0;
    ne=new Set;
    ee=new Map;
    re;
    ie=new Map;
    se=0;
    Bt;
    oe=typeof Temporal !== "undefined";
    constructor(t) {
        this.Zn = t;
        this.Bt = t.Bt;
    }
    async serialize() {
        const t = this.se;
        this.se = 0;
        try {
            await this.outputRoots();
        } finally {
            this.se = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.se;
        this.se = s;
        this.Bt.write(Qi);
        this.Zn.le = 0;
        try {
            this.Bt.write(t + "");
            this.Bt.write(Yi);
            this.Bt.write(Qi);
            await this.outputSelectedRoots(n);
            this.Bt.write(Ji);
            const s = this.getForwardRefsPayload();
            this.Zn.le = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Bt.write(Yi);
                s ? this.outputForwardRefsArray(s) : this.Bt.write("0");
            }
            if (e !== void 0) {
                this.Bt.write(Yi);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Bt.write(Hi);
                    this.writeRootRefPath(e);
                    this.Bt.write(Hi);
                }
            }
        } finally {
            this.se = o;
        }
        this.Bt.write(Ji);
    }
    ue(t) {
        this.Bt = t;
    }
    outputArray(t, n, e) {
        this.Bt.write(Qi);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Bt.write(Yi) : s = !0;
            e(t[n], n);
        }
        this.Bt.write(Ji);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Hi + t + Hi;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Bt.write(n.slice(s, e));
            this.Bt.write("<\\/");
            s = e + 2;
        }
        this.Bt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Bt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Bt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Bt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Bt.write(Hi);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Bt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Bt.write(Hi);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Bt.write(t + Yi);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Bt.write(Hi);
                this.writeRootRefPath(n);
                this.Bt.write(Hi);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Bt.write(t + Yi);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Bt.write(t + Yi + n);
        } else if (typeof n === "string") {
            this.Bt.write(t + Yi);
            this.outputString(n);
        } else {
            this.Bt.write(t + Yi);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Zn.getSeenRef(t);
        const o = !e && this.ee.get(t);
        if (s) {
            s.re && this.isSeenInStreamedRoot(s) && (s = this.Zn.ce(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Zn.fe(t, this.re, n);
            }
            s = this.Zn.kt(t, !0);
        }
        if (s.re) {
            if (this.re) {
                this.Zn.ae(s, t);
            } else {
                this.Zn.ae(s, t, n);
                t = this.Zn.he[n];
            }
        }
        if (typeof o === "number") {
            this.Pt[o] = s.Lt;
            this.ee.delete(t);
        }
        const r = t instanceof gc ? t.de : s.Lt;
        if (!this.re && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.re; ) {
            t = t.re;
        }
        return t.Lt < this.se;
    }
    writeValue(t, n) {
        if (Nf(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === xs) {
                    this.output(3, 7);
                } else if (t === js) {
                    this.output(3, 8);
                } else if (t === gs) {
                    this.output(3, 9);
                } else {
                    if (t !== uc) {
                        throw er(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === qo) {
                    this.output(3, 10);
                } else if (t === Mo) {
                    this.output(3, 11);
                } else if (ir(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = Ln(this.Zn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Zn.kt(n);
                            const i = this.Zn.kt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.ie.get(l);
                            if (u) {
                                const t = this.Zn.kt(u);
                                this.output(1, t);
                                return;
                            }
                            this.ie.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!nh(t)) {
                        throw er(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[th];
                        this.Zn.pe.add(n.bt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Ss) {
                    this.output(3, 5);
                } else if (t === ks) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof gc) {
                    this.output(1, t.de);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.re;
                        this.re = e;
                        this.writeObjectValue(t);
                        this.re = n;
                    }
                }
                break;

              default:
                throw er(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (Ns(t)) {
            const n = t[vs];
            this.output(38, [ bc(n), n.varProps, n.constProps, t[bs].ft ]);
        } else if (t instanceof lo) {
            const {L: n, et: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof Cs) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof hc) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (ec(t)) {
            const n = Gu(t);
            const e = Zu(t);
            const s = n.h;
            const o = n.ft;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Zn.$t.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Bu(t)) {
            const n = t[Lf](t);
            if (si(n)) {
                const t = this.resolvePromise(n, (t, n) => new pc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.re.Lt;
                this.re = this.re.re;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        Nf(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Zn.$e(t)) {
            this.Zn.ye(t.we, 16);
            this.output(11, t.we.id);
        } else if (t instanceof Fs) {
            if (t instanceof Us) {
                const n = function e(t, n) {
                    if (n === xs) {
                        return n;
                    }
                    return li(t.jt.resolved || t.jt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Lf in n && (e = n[Lf](n));
                        e === void 0 && (e = xs);
                        return e;
                    });
                }(t, t.Ot);
                if (si(n)) {
                    const e = this.resolvePromise(n, (n, e) => new pc(34, n, e, t.ft, t.jt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.jt, t.ft, n ]);
                }
                return;
            }
            if (t instanceof oo) {
                this.output(31, [ ...Xn(this.Zn, t), t.h, t.m, ...t.ft || [] ]);
            } else if (t instanceof Ws) {
                let n = t.Ot;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = Nf(t.Ot);
                const i = !!(t.h & 512);
                const c = i && !!t.Xt;
                const l = i && t.Mt !== 0 ? t.Mt : void 0;
                const u = i && t.Dt !== 1 ? t.Dt : void 0;
                const f = i && t.Vt !== 0 ? t.Vt : void 0;
                const a = i && t.h & -25 || void 0;
                o || r || c ? n = xs : e ? n = t.Ot : s && (n = xs);
                const h = [ t.jt, t.ft ];
                if (i) {
                    h.push(t.yt, t.wt, t.Xt);
                    h.push(a || void 0);
                }
                n === xs && l === void 0 && u === void 0 && f === void 0 || h.push(n === void 0 ? uc : n);
                if (i) {
                    h.push(l);
                    h.push(u);
                    h.push(f);
                }
                this.output(i ? 33 : 32, h);
            } else {
                const n = t.Ot;
                const e = [ n === void 0 ? uc : n ];
                t.ft && e.push(...t.ft);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            for (const e of Object.entries(t)) {
                if (__EXPERIMENTAL__.errorBoundary && e[0] === oc) {
                    continue;
                }
                n.push(e[0], e[1]);
            }
            __EXPERIMENTAL__.errorBoundary && lc(t) && n.push(oc, 1);
            this.output(23, n);
        } else if (this.Zn.me(t)) {
            if (t.vnodeData && t.vnodeData[0] & 32 && ar(t.id)) {
                this.output(3, 0);
                return;
            }
            const n = this.Zn.kt(t);
            this.Zn._e(t, Vr, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                $c(e, t => {
                    this.Zn.kt(t);
                });
                this.Zn.ye(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Zn.ye(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (fo(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Ou) {
            const n = [ t.vt, t.h, t.Lt, t.ht ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (si(t)) {
            const n = this.resolvePromise(t, (t, n) => new pc(24, t, n));
            this.output(2, n);
        } else if (t instanceof pc) {
            if (t.ve === 34) {
                if (t.vt) {
                    this.output(34, [ t.vt, t.ft, t.be ]);
                } else {
                    if (!t.Ee) {
                        console.error(t.be);
                        throw er(33);
                    }
                    {
                        const n = this.re.Lt;
                        this.re = this.re.re;
                        this.writeValue(t.be, n);
                    }
                }
            } else {
                this.output(24, [ t.Ee, t.be ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof vc) {
            const n = t.ge;
            if (this.getSeenRefOrOutput(n, this.re.Lt, !0)) {
                let t = this.ee.get(n);
                if (t === void 0) {
                    t = this.te++;
                    this.ee.set(n, t);
                    this.Pt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.oe && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.oe && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.oe && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!kl(t)) {
                throw er(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.te++;
        t.then(s => {
            this.ne.delete(t);
            this.Pt[e] = this.Zn.kt(n(!0, s));
        }).catch(s => {
            this.ne.delete(t);
            this.Pt[e] = this.Zn.kt(n(!1, s));
        });
        this.ne.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Zn.Se + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {he: n} = this.Zn;
        for (;this.Kn < n.length || this.ne.size; ) {
            let e = t > 0;
            for (;this.Kn < n.length; this.Kn++) {
                e ? this.Bt.write(Yi) : e = !0;
                this.writeValue(n[this.Kn], this.Kn);
                t++;
            }
            if (this.ne.size) {
                try {
                    await Promise.race(this.ne);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.ne.size; ) {
            if (e < t.length) {
                n ? this.Bt.write(Yi) : n = !0;
                const s = t[e++];
                this.writeValue(this.Zn.he[s], s);
                continue;
            }
            try {
                await Promise.race(this.ne);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Pt.length - 1;
        for (;t >= 0 && this.Pt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Pt.length - 1 ? this.Pt : this.Pt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Bt.write(Hi);
                this.writeRootRefPath(t);
                this.Bt.write(Hi);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Bt.write(Qi);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Zn.ke = this.Zn.he.length;
        this.Zn.Re = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Bt.write(Yi);
            this.Bt.write(14 + Yi);
            this.outputForwardRefsArray(n);
        }
        this.Bt.write(Ji);
        this.Zn.Pe = this.Zn.he.length + (this.Zn.Re ? 1 : 0);
        this.Zn.le = e;
    }
}

class pc {
    ve;
    Ee;
    be;
    ft;
    vt;
    constructor(t, n, e, s, o) {
        this.ve = t;
        this.Ee = n;
        this.be = e;
        this.ft = s;
        this.vt = o;
    }
}

const $c = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (yc(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === Vr || t === zr && (zi(s) || wc(e, s))) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const yc = t => typeof t === "object" && t !== null && !zi(t);

const wc = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, hr)) {
        return !1;
    }
    const s = n[vs];
    return zi(s.varProps) && !mc(n) && !_c(t[Pr]);
};

const mc = t => !!t[bs].ft?.size;

const _c = t => t instanceof Map && t.has(":");

function Xn(t, n) {
    n.Rt && n.Rt[0] === "{" && (n.Rt = `(${n.Rt})`);
    const e = t.gt(n.Rt, n.ut.length, n.lt);
    return [ e, n.ut ];
}

class vc {
    ge;
    constructor(t) {
        this.ge = t;
    }
}

const bc = t => new vc(t);

let Ec = () => !1;

class gc {
    de;
    constructor(t) {
        this.de = t;
    }
}

class Sc {
    NodeConstructor;
    DomRefConstructor;
    St;
    _e;
    $t;
    Bt;
    Te=new Map;
    Ae=new Map;
    Me=0;
    Ie=[];
    he=[];
    qe=[];
    Ne;
    Se=0;
    Pe=0;
    le=0;
    ke=0;
    Re=!1;
    It=new Set;
    Ct=new Set;
    xt=new Set;
    pe=new Set;
    xe;
    ye=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this._e = s;
        this.$t = o;
        this.Bt = r;
        this.xe = new dc(this);
    }
    async zt() {
        await this.xe.serialize();
    }
    async Ce(t, n, e, s) {
        await this.xe.serializePatch(t, n, e, s);
    }
    ue(t) {
        this.Bt = t;
        this.xe.ue(t);
    }
    getSeenRef(t) {
        return this.Te.get(t);
    }
    fe(t, n, e) {
        const s = {
            Lt: e,
            re: n
        };
        this.Te.set(t, s);
        return s;
    }
    Le(t) {
        const n = [];
        for (;t.re; ) {
            n.unshift(t.Lt);
            t = t.re;
        }
        n.unshift(t.Lt);
        return n;
    }
    ae(t, n, e) {
        const s = this.Le(t);
        const o = e === void 0;
        e === void 0 && (e = this.he.length);
        this.he[e] = new gc(s);
        o && (this.qe[e] = n);
        t.re = null;
        t.Lt = e;
        o && this.Ne?.(e, this.he[e], n);
    }
    kt(t, n = !1) {
        let e = this.Te.get(t);
        let s;
        if (e) {
            e.re && this.ae(e, t);
            s = e.Lt;
        } else {
            s = this.he.length;
            e = {
                Lt: s
            };
            this.Te.set(t, e);
            this.he.push(t);
            this.qe.push(t);
            this.Ne?.(s, t, t);
        }
        return n ? e : s;
    }
    ce(t) {
        const n = this.he.length;
        const e = {
            Lt: n
        };
        this.Te.set(t, e);
        this.he.push(t);
        this.qe.push(t);
        this.Ne?.(n, t, t);
        return e;
    }
    Oe(t, n) {
        const e = this.he.length;
        const s = {
            Lt: e
        };
        this.Te.set(n, s);
        this.he.push(t);
        this.qe.push(n);
        return e;
    }
    me(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    $e(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    je(t) {
        const n = this.Te.get(t);
        return n && (n.re ? void 0 : n.Lt);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.Ae.get(t);
        if (o === void 0) {
            o = this.Me + this.Ie.length;
            this.Ae.set(t, o);
            if (s) {
                this.Ie.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Ie.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Xe(t, n) {
        this.Me = t;
        if (n) {
            this.Ae.clear();
            for (let t = 0; t < n.length; t++) {
                this.Ae.set(n[t], t);
            }
        }
    }
}

const kc = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Bi(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    Ec = n ? t => t instanceof n : () => !1;
    return new Sc(t, n, e, s, o, r);
};

const Rc = (t, n) => t[n];

const Pc = (t, n) => {
    for (const e in t) {
        if (!Tc(wa(Rc, t, e), n)) {
            return !1;
        }
    }
    return !0;
};

const Tc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        ec(t) && (t = Zu(t));
        if (s == Object.prototype) {
            return Pc(t, n);
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Tc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (ju(t)) {
            return !0;
        }
        if (Ns(t)) {
            return !0;
        }
        if (si(t)) {
            return !0;
        }
        if (fo(t)) {
            return !0;
        }
        if (Bu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            try {
                t.message;
                t.stack;
            } catch {
                return !1;
            }
            return Pc(t, n);
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof lo) {
            return !0;
        }
        if (Ec?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (ir(t) || nh(t) || t === qo || t === Mo) {
            return !0;
        }
    } else if (t === gs || t === xs || t === js) {
        return !0;
    }
    return !1;
};

const Ac = (t, n) => {
    let e = kl(t) ? gn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Ze(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let Mc = !1;

const Ic = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (Mc = !0);
            const n = `{${Ze(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Ac(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Nc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Ic(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${qc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = Mc ? "" : `(${JSON.stringify(t).length} chars)`;
        Mc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const qc = t => ac[t] || `Unknown(${t})`;

const Nc = t => fc[t] || `Unknown(${t})`;

function Fn(t, n, e, s = 0) {
    const o = Dn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Dn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Pt = t[i + 1]);
        yield;
    }
}

const xc = new WeakMap;

const Cc = /^[A-Za-z0-9+/]*$/;

const Lc = t => {
    const n = t.Ut === void 0;
    t.Ut ??= new Map;
    return n;
};

const Oc = (t, n) => {
    if (n) {
        t.Ut.clear();
        t.Ut = void 0;
    }
};

const jc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Qt(e);
        return s === -1 || s === void 0 ? gs : t._(s);

      case 14:
        return e;

      case 3:
        return cc[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t._(i);
                const f = t._(l);
                n = On(u, f, r !== -1 ? s : null, t);
            } else {
                n = On("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Ou(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Ka(null);

      case 30:
        return new Fs(t, 0);

      case 31:
        return new oo(t, null, null, null);

      case 32:
        return new Ws(t, null);

      case 33:
        return new zs(t, null, void 0, {});

      case 34:
        return new Us(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = jc(t, s, o);
            const i = rc(r, 0, t);
            bf(s) && t.Ut.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new uo(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        xc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !Cc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw er(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return w(null);

      case 10:
        return Wn(t, e);

      case 11:
        const l = Wn(t, e);
        if (kl(l)) {
            uu(l);
            return Tu(l);
        }
        throw er(17, [ typeof l ]);

      case 39:
        return new lo({});

      case 42:
        return new lo({
            L: null,
            et: !0
        });

      case 43:
        return new lo({
            L: null,
            et: !1
        });

      case 40:
      case 44:
        return new Cs(null, null, null, null);

      case 41:
        return new hc;

      default:
        throw er(18, [ n ]);
    }
};

function Wn(t, n) {
    return n ? t.rootVNode ? Fl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Xc = (t, n, e) => {
    let s = null;
    let o = null;
    if (nr(t)) {
        o = t;
    } else {
        if (!tr(t)) {
            throw er(7, [ t ]);
        }
        s = t;
    }
    return Da(s, n, null, o, e);
};

const Fc = (t, n, e) => Da(null, n, t, null, e);

const Dc = (t, n) => Da(null, t, null, null, n);

const Wc = (t, n, e) => {
    const s = Dc(t, e);
    return s;
};

const Vc = (t, n, e, s) => Da(t, e, null, n, s);

const Uc = (t, n, e, s, o) => {
    const r = Vc(t, n, e, o);
    r.Fe(s);
    return r;
};

const zc = (t, n, e, s) => {
    const o = Xc(t, n, s);
    return o;
};

const Bc = (t, n, e, s) => {
    const o = Fc(t, n, s);
    return o;
};

const Hc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Qc = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Vn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Jc = (t, n, e) => new oo(null, t, n, e || null);

class Yc {
    De;
    $t;
    We=null;
    En=!1;
    sn;
    _;
    fn;
    Ve=0;
    Jt=null;
    Ue=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.fn = t;
        this.sn = n;
        this.De = Gi;
        this.$t = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return va(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return kc(t, n, e, this.setHostProp.bind(this), this.$t, s);
    }
    dt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Gc = Symbol();

const Qd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Gc] = t;
    return n;
};

const Zc = (t, n, e, s) => {
    const o = t.getOrCreateLastNode();
    return cl(t, o, n, e, s.props);
};

const Kc = (t, n, e) => {
    const s = t.getOrCreateLastNode();
    const [o] = e[th];
    const r = n.props;
    r && r.children && delete r.children;
    s.setProp(hr, o);
    s.setProp(zr, r);
    n.key !== null && s.setProp(Ur, n.key);
    return cl(t, s, s, o, r);
};

class tf {}

class nf {}

const ef = /*#__PURE__*/ new WeakMap;

const rf = t => {
    const n = ef.get(t);
    if (!n || n.length === 0) {
        return !1;
    }
    for (let t = n.length - 1; t >= 0; t--) {
        if (n[t].vnodeData[0] & 32) {
            return !0;
        }
    }
    return !1;
};

const sf = (t, n, e = null) => {
    n.catch(n => {
        try {
            t.handleError(n, e);
        } catch {}
    });
};

function Un(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function zn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = n => {
        sf(t, n);
        o.push(n);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === tf) {
                    const e = o.pop();
                    if (__EXPERIMENTAL__.errorBoundary && rf(t)) {
                        continue;
                    }
                    try {
                        await n(() => o.push(e()));
                    } catch (n) {
                        o.push(Hn(t, t.getOrCreateLastNode(), n, "async-signal"));
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.errorBoundary && e === nf) {
                    const n = o.pop();
                    if (rf(t)) {
                        continue;
                    }
                    try {
                        const e = n.apply(t);
                        si(e) && await e;
                    } catch (n) {
                        o.push(Hn(t, t.getOrCreateLastNode(), n));
                    }
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        const n = o.pop();
                        if (__EXPERIMENTAL__.errorBoundary && rf(t)) {
                            continue;
                        }
                        o.push(__EXPERIMENTAL__.errorBoundary ? await Yn(t, t.getOrCreateLastNode(), () => n) : await n);
                    } else {
                        const n = e.apply(t);
                        si(n) && await n;
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.errorBoundary && rf(t)) {
                    si(e) && e.catch(() => {});
                    continue;
                }
                Zn(t, r, i, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                si(n) && await n;
            }
        }
    })();
}

function Bn(t) {
    for (let n = t; n; n = n.parentComponent) {
        const t = n.getProp(Rr);
        if (t != null && Ye(t, Df.id, 0)) {
            return n;
        }
    }
    return null;
}

function Hn(t, n, e, s = "render") {
    for (let o = Bn(n); o; o = Bn(o.parentComponent)) {
        const n = t.resolveContext(o, Df);
        if (!n || !n.Tt) {
            continue;
        }
        if (__EXPERIMENTAL__.errorBoundary && Ki(t) && n.At) {
            throw e;
        }
        Zf(n, e, s);
        if (__EXPERIMENTAL__.errorBoundary) {
            Ki(t) && Jf(n);
            Qn(t, o);
        }
        return null;
    }
    throw e;
}

function Qn(t, n) {
    const e = new Map;
    for (let t = n; t; t = t.parentComponent) {
        t.id && e.set(t.id, t);
    }
    const s = n.children;
    if (s) {
        for (let n = 0; n < s.length; n++) {
            Jn(t, s[n], e);
        }
    }
}

function Jn(t, n, e) {
    n.vnodeData[0] |= 32;
    const s = n.getProp(yr);
    if (s) {
        const t = e.get(s);
        t && t.removeProp(n.getProp($r) ?? "");
    }
    ar(n.id) && kn(t, n);
    const o = n.getProp(Br);
    if (o) {
        for (let n = 0; n < o.length; n++) {
            const e = o[n];
            ju(e) && kn(t, e);
        }
    }
    const r = n.children;
    if (r) {
        for (let n = 0; n < r.length; n++) {
            Jn(t, r[n], e);
        }
    }
}

function Yn(t, n, e, s = "render") {
    try {
        const o = e();
        return si(o) ? o.catch(e => Hn(t, n, e, s)) : o;
    } catch (e) {
        return Hn(t, n, e, s);
    }
}

function Gn(t, n) {
    if (__EXPERIMENTAL__.errorBoundary && typeof n === "function") {
        t(n);
        t(nf);
    } else {
        t(n);
    }
}

function Zn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                Gn(n, s[t]);
            }
        } else if (Fu(s)) {
            (function e(t, n) {
                const e = n instanceof oo ? n.it() : n;
                if (e instanceof Ws) {
                    const n = e.Mt;
                    if (n && !(e.h & 256)) {
                        t.kt(e);
                        t.It.add(e);
                    }
                }
            })(t.serializationCtx, s);
            t.openFragment(ks);
            const o = t.getOrCreateLastNode();
            const r = s instanceof oo ? s.it() : s;
            n(t.closeFragment);
            n(() => va(r, o, ".", t));
            n(tf);
        } else if (si(s)) {
            t.openFragment(ks);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                if (__EXPERIMENTAL__.errorBoundary && rf(t)) {
                    return;
                }
                const n = () => ({
                    currentStyleScoped: o.currentStyleScoped,
                    parentComponentFrame: o.parentComponentFrame
                });
                try {
                    for await (const e of s) {
                        await zn(t, e, n());
                        await t.streamHandler.flush();
                    }
                } catch (e) {
                    const s = Hn(t, t.getOrCreateLastNode(), e, "async-generator");
                    await zn(t, s, n());
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = As(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                __EXPERIMENTAL__.errorBoundary && As(r, br) && n(((t, n) => {
                    let e = ef.get(t);
                    e || ef.set(t, e = []);
                    e.push(n);
                    return () => {
                        e.pop();
                    };
                })(t, t.getOrCreateLastNode()));
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && Gn(n, l);
            } else if (nr(i)) {
                if ((__EXPERIMENTAL__.suspense || __EXPERIMENTAL__.errorBoundary) && (t => typeof t === "function" && Gc in t)(i)) {
                    n(() => (t => t[Gc])(i)(t, r, o, n));
                    return;
                }
                if (i === Mo) {
                    const e = r.key != null ? {
                        [Ur]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && Gn(n, s);
                } else if (i === qo) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        const c = As(r, Lr);
                        c && (i[Lr] = c);
                        i[yr] = s;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = k(l, r, t);
                        i[$r] = f;
                        n(Un(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const a = r.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        Gn(n, h);
                        n(Un(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = ks;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === Co) {
                    t.commentNode(As(r, "data") || "");
                } else if (i === Oo) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = nr(s) ? s({
                        async write(n) {
                            await zn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    si(i) ? e(i) : n(i);
                } else if (i === xo) {
                    t.htmlNode(As(r, "data"));
                } else if (i === Lo) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    Gn(n, r.children);
                } else if (nh(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = __EXPERIMENTAL__.errorBoundary ? Yn(t, s, () => Kc(t, r, i)) : Kc(t, r, i);
                    n(Un(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (si(l)) {
                        sf(t, l, s);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = ai(s.getProp(kr));
                            n(e);
                            n(Un(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = ai(s.getProp(kr));
                        n(Un(o, t, c));
                    }
                } else {
                    const s = {
                        [Ur]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = __EXPERIMENTAL__.errorBoundary ? Yn(t, t.getOrCreateLastNode(), () => Zc(t, o && o.componentNode, i, r)) : Zc(t, o && o.componentNode, i, r);
                    si(c) ? e(c) : n(c);
                }
            }
        }
    }
}

const of = () => Ca;

const lf = async t => {
    const [n, e] = Ca;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = qn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const uf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ko();
    if (e) {
        return e;
    }
    const r = Da(null, "_rsc", lf, null, [ t, {} ], o.$);
    const i = Qs(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const cf = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (si(t)) {
        return t.then(n, s);
    }
    const o = ff(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return si(i) ? i.then(n, s) : n(i);
};

const ff = t => t && t.__brand === "resource";

function Kn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n.bt.startsWith("_") || !Array.isArray(n.Nt) && !s || (n = Da(null, "_run", N, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = Ln(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (ir(o)) {
                i(c(o));
                te(t, n, o);
            } else if (o != null) {
                const e = Kn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (ir(r)) {
        o = c(r);
        te(t, n, r);
    }
    return o;
}

function te(t, n, e) {
    const s = $i(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.xt.add(r);
        t.Ct.add(e);
    }
}

const af = (t, n, e) => {
    pf(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const hf = (t, n, e) => {
    pf(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const df = (t, n, e) => {
    pf(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const pf = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = $f();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + pi(i), e, s);
            }
        } else {
            r(t + pi(n), e, s);
        }
    }
};

const $f = () => {
    const t = $a();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Gr);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Gr, s);
    }
    let o = t.$.getHostProp(e, Zr);
    o === null && (o = 0);
    t.$.setHostProp(e, Zr, o + 1);
    let r = t.$.getHostProp(e, Kr);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Kr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const yf = function(t, n) {
    const e = Ae(n);
    return la(e, () => {
        typeof this === "string" && La(Oa(e, this));
        const s = Ca?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = Ca?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        yn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let wf;

function ne(t) {
    const n = da();
    if (!n) {
        return;
    }
    wf ||= Fc(yf, "_hmr");
    const e = n.m;
    const s = wf.w([ e, t ]);
    hf("qHmr", s);
}

function ee(t, n, e, s, o) {
    const r = Sl();
    Nl(r, $r, o);
    r.parent = n;
    Nl(n, o, r);
    Nl(r, hr, e);
    Nl(r, zr, s);
    r.dirty = 4;
    hn(t, r, 1);
    return r;
}

function re(t, n) {
    Nl(t, dr, n);
    t.flags |= 2048;
}

function ie(t, n, e) {
    Nl(n, zr, e);
    yn(t, n, 4);
}

function se(t, n, e, s) {
    Nl(n, s, null);
    const o = [];
    gt(t, o, e);
    Bl(o);
    if (e.flags & 2048) {
        const t = ql(e, dr, null);
        t && t.replaceChildren();
        Nl(e, dr, null);
        e.flags &= -2049;
    }
}

let mf = Promise.resolve();

const _f = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const vf = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !_f.has(t));
};

function* oe(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ue(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* le(t, n, e = Array(n.length / 2)) {
    const s = Lc(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t._;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : jc(t, i, c);
        }
        return e[s];
    };
    t._ = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            bf(r) && (yield* ce(t, c, r, i));
            yield;
        }
    } finally {
        t._ = i;
        Oc(t, s);
    }
    return e;
}

function* ue(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = jc(t, n, e);
    bf(n) && (yield* ce(t, s, n, e));
    return s;
}

function* ce(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* oe(t, s));
    switch (e) {
      case 4:
        yield* oe(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!vf(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = xc.get(t);
            if (e) {
                if (xc.has(o)) {
                    throw er(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                if (__EXPERIMENTAL__.errorBoundary && s === oc) {
                    Object.setPrototypeOf(n, sc.prototype);
                    continue;
                }
                vf(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t.vt = e[0];
            t.h = e[1];
            t.Lt = e[2];
            t.ht = e[3];
            break;
        }

      case 29:
        n[th][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Ot = e[0];
            t.ft = new Set(e.slice(1));
            ae(t.ft, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.lt = t.getSyncFn(o[0]);
            e.ut = o[1];
            e.Ot = xs;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ft = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && kl(t.m)) {
                    const n = t.m;
                    const e = t.ft;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (tr(e)) {
                                const o = ql(n, e, null);
                                if (o !== null) {
                                    t.Ot = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = lu(n);
                        e && n.firstChild === n.lastChild && Al(e) && (t.Ot = su(e));
                    }
                }
            })(e);
            ae(e.ft, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.jt = e[0];
            e[1] && (t.ft = new Set(e[1]));
            e[2] && (t.yt = new Set(e[2]));
            e[3] && (t.wt = new Set(e[3]));
            e[4] && (t.Xt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Ft = !0);
            const o = e.length > 6;
            o && (t.Ot = e[6]);
            t.Ot === xs && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.Dt = e[8] ?? 1;
                t.Wt = [];
            }
            t.Vt = e[9] ?? 0;
            ae(t.ft, t);
            ae(t.yt, t);
            ae(t.wt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.jt = r[0];
            const i = o.jt.resolve(t).catch(() => {});
            mf = mf.finally(() => i);
            r[1] && (o.ft = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Ot = r[2]);
            e !== 34 && o.Ot !== xs && (o.h &= -2);
            ae(o.ft, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === gs) {
                o = new uo(Mo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[vs] = o;
            const r = t[bs];
            r.ft = e[3];
            he(r.ft, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.L = s[0];
            t.data.et = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            fe(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            fe(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = nc(n);
            const o = t.Ut.get(e);
            if (o) {
                t.Ut.delete(e);
                yield* ce(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Gu(n);
            c.h = r;
            c.ft = i;
            he(c.ft, e);
            break;
        }

      default:
        throw er(16, [ e ]);
    }
}

function fe(t) {
    const n = De;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[ts] ||= new Map;
    e[ts].set(t.property, t);
}

function ae(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function he(t, n) {
    if (t) {
        for (const [, e] of t) {
            ae(e, n);
        }
    }
}

const bf = t => t >= 23 || t === 4 || t === 5;

const Ef = new WeakMap;

const gf = Symbol();

const Sf = (t, n) => {
    if (!Array.isArray(n) || kl(n) || (t => Ze(t) && gf in t)(n)) {
        return n;
    }
    let e = Ef.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new kf(t, n));
        Ef.set(n, e);
    }
    return e;
};

class kf {
    $;
    ze;
    constructor(t, n) {
        this.$ = t;
        this.ze = n;
    }
    get(t, n, e) {
        if (n === gf) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.ze.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.ze[o];
        const i = this.ze[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Lc(c);
        try {
            const e = jc(c, r, i);
            Reflect.set(t, n, e);
            this.ze[o] = 0;
            this.ze[o + 1] = e;
            bf(r) && ((t, n, e, s) => {
                const o = Lc(t);
                try {
                    const o = ce(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    Oc(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            Oc(c, l);
        }
    }
    has(t, n) {
        if (n === gf) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === gf) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.ze.length / 2) {
            return o;
        }
        const i = r * 2;
        this.ze[i] = 0;
        this.ze[i + 1] = e;
        return !0;
    }
}

const Rf = t => {
    if (!t.Be) {
        t.Be = !0;
        t.He();
    }
};

const Pf = (t, n, e) => {
    const s = {
        Qe: t,
        He: void 0,
        Be: !1
    };
    const o = Ei(() => {
        ((t, n, e) => {
            t.Be = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Qe.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        Rf(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.an?.();
            n(t);
        }, t => {
            o.an?.();
            e(t);
        });
    });
    s.He = o;
    return s;
};

async function de(t) {
    const n = kc(null, null, () => "", () => {}, new WeakMap);
    n.kt(t);
    await n.zt();
    return n.Bt.toString();
}

async function pe(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = we(n, () => e);
    s.Ht = e;
    await Tf(le(s, n, e));
    return e[0];
}

const Tf = t => new Promise((n, e) => {
    const s = Pf(t, n, e);
    Rf(s);
});

function $e(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function ye(t) {
    let n;
    const e = we(t, () => n);
    n = Sf(e, t);
    e.Ht = n;
    return e;
}

function we(t, n) {
    const e = {
        _: t => $e(t, n()),
        Qt: t => e.Pt?.[+t],
        getSyncFn: () => () => {},
        $t: new WeakMap,
        element: null,
        Pt: null
    };
    Fn(t, e);
    return e;
}

const Af = (t, n) => {
    const e = new WeakSet;
    return wa(Mf, t, e, "_", n);
};

const Mf = (t, n, e, s) => {
    const o = nc(t);
    if (o == null) {
        return t;
    }
    if (qf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Fu(o)) {
            return t;
        }
        if (Tc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (si(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Ke(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw er(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw er(3, [ o ]);
                    }
                    Mf(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof os) {
                return t;
            }
            if (Ge(o)) {
                for (const [t, s] of Object.entries(o)) {
                    Mf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw er(3, [ i ]);
    }
    return t;
};

const If = /*#__PURE__*/ new WeakSet;

const qf = t => {
    if (Ze(t) || nr(t)) {
        return !If.has(t) && !(Cf in t);
    }
    return !0;
};

const Nf = t => !!t && (Ze(t) || typeof t === "function") && (If.has(t) || Cf in t);

const xf = t => {
    (Ze(t) && t !== null || typeof t === "function") && If.add(t);
    return t;
};

const Cf = Symbol();

const Lf = Symbol();

const Of = t => /*#__PURE__*/ Object.freeze({
    id: pi(t)
});

const jf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ko();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const Xf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ko();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(Ce(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw er(8, [ t.id ]);
};

const Ff = t => {
    const n = pa();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const Df = /*#__PURE__*/ Of("qk-error");

const Wf = (t, n) => {
    try {
        return t();
    } catch {
        return n;
    }
};

const Vf = "An error occurred";

const Uf = /*#__PURE__*/ Symbol();

const zf = t => {
    const n = Error(Vf);
    n.digest = (t => wi(Wf(() => t instanceof Error ? `${t.name}: ${t.message}\n${t.stack ?? ""}` : t + "", "unknown")))(t);
    Object.defineProperty(n, Uf, {
        value: !0
    });
    return n;
};

const Bf = t => {
    if (t instanceof Error) {
        return t;
    }
    let n;
    try {
        n = t + "";
    } catch {
        try {
            n = Object.prototype.toString.call(t);
        } catch {
            n = Vf;
        }
    }
    const e = Error(n);
    e.cause = t;
    return e;
};

const Jd = (t, n = !1, e) => {
    try {
        if (e) {
            const n = e(t);
            return n instanceof Error && (t => Wf(() => {
                t.message;
                t.name;
                for (const n in t) {
                    t[n];
                }
                return !0;
            }, !1))(n) ? n : zf(t);
        }
        if (lc(t)) {
            return t;
        }
        if (Wf(() => t instanceof Error && Uf in t, !1)) {
            return t;
        }
        if (!n) {
            return zf(t);
        }
        if (t instanceof Error) {
            return t;
        }
        const s = t?.message;
        if (typeof s === "string") {
            const n = Error(s);
            n.cause = t;
            return n;
        }
        return Bf(t);
    } catch {
        return zf(t);
    }
};

const Hf = (t, n, e) => {
    if (!t) {
        return;
    }
    try {
        Promise.resolve(t(Bf(n), e)).catch(ze);
    } catch (t) {
        ze(t);
    }
};

const Qf = /*#__PURE__*/ new WeakSet;

const Jf = t => {
    Qf.add(t);
};

const Yf = /*#__PURE__*/ Symbol();

const Gf = (t, n) => {
    if (t === null || typeof t !== "object" && typeof t !== "function") {
        return;
    }
    try {
        Object.defineProperty(t, Yf, {
            value: n,
            configurable: !0
        });
    } catch {}
};

const Yd = t => t === null || typeof t !== "object" && typeof t !== "function" ? void 0 : Wf(() => t[Yf], void 0);

const Zf = (t, n, e = "render") => {
    t.error = n === void 0 ? Error("undefined") : n;
    Hf(t.Je, n, {
        phase: Yd(n) ?? e,
        boundaryId: t.boundaryId ?? ""
    });
};

const Gd = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Kf = "_suC";

const Zd = new WeakMap;

class Kd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = tp(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Gd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const tp = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const np = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = da()?.$;
    return t?.outOfOrderStreaming === !0 && !Ki(t);
};

const ta = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && zu(t, n, r);
};

const na = new WeakMap;

function* me(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Jt}"]${mr}`);
    const o = ea(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(_r) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* _e(t, e, i.textContent);
        yield;
    }
}

const ea = t => {
    let n = na.get(t);
    if (!n) {
        n = new WeakSet;
        na.set(t, n);
    }
    return n;
};

function* _e(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.Yt.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.Yt[e * 2 + t] = s[t];
            yield;
        }
        yield* Dn(n.Yt, t, e * 2);
        n.Gt = Sf(t, n.Yt);
        n.Gt.length = n.Yt.length / 2;
        n.Zt = n.Pt;
    }(t, n, s, o);
    ra(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t._(s.rootId);
            const r = s.subscriptions;
            if (o instanceof Fs) {
                r instanceof Set && ta(t, o, o, o.ft ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Gu(o);
                const e = Zu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ft ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    ta(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n._(i));
}

const ra = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Zt ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Pt = e;
};

const ia = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function ve(t, n) {
    const e = t.qVNodeDataState ||= {
        Kt: [],
        tn: null
    };
    t.qProcessVNodeDataPatch ||= n => ve(t, ge(t, n));
    t.qVNodeDataReady = !1;
    e.Kt.push(n);
    be(t, e);
}

function be(t, n) {
    if (n.tn) {
        return;
    }
    const e = n.Kt.shift();
    if (!e) {
        Ee(t);
        return;
    }
    n.tn = Pf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.tn = null;
            be(t, n);
        }
    }, e => {
        n.tn = null;
        ze(e);
        Ee(t);
    });
    Rf(n.tn);
}

function Ee(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* ge(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* Se(t, s || void 0, e, o, n.textContent));
}

function* Se(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const _ = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* _(s));
            yield;
        }
    };
    const m = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const b = t => {
        for (;t && (t = t.nextSibling) && m(t) === 0; ) {}
        return t;
    };
    const v = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let _ = 0;
        let E = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;sa(_ = r.charCodeAt(y)); ) {
                t += 1 << _ - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : m(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = b(e)); ) {
                    e = e.parentNode;
                }
                yield* v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (m(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = m(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = b(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (m(S) !== 8);
                yield* v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = b(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* v(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += k();
                        if (_ === 126) {
                            E = p;
                            y++;
                            _ = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = oa(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    E !== h || u && s === e || i.set(u ? fr(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== cr || n.charCodeAt(1) !== cr || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* g(c, s, t);
                    S = b(s);
                    S && (n.currentNode = S);
                }
            }
            yield;
        } while (s = S || n.nextNode());
    };
    const E = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* v(r, e, e, b(e), s, n.qVNodeRefs, n, o);
    };
    const g = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* E(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* g(e, s, n, o) : yield* E(e, s, o);
        return;
    }
    yield* _(t);
    const S = t.createTreeWalker(t, 129);
    yield* v(S, null, S.firstChild(), null, "", null, null);
}

const sa = t => 33 <= t && t <= 46;

const oa = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && sa(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function ke(t) {
    return t.nn === 3;
}

function Re(t, n) {
    const e = t.en ||= {
        Kt: [],
        tn: null
    };
    t.nn = 2;
    e.Kt.push(n);
    Pe(t, e);
}

const la = (t, n) => {
    const e = t;
    if (ke(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!ke(e)) {
                    (e.rn ||= []).push(s);
                    return;
                }
                ia(e.document, () => {
                    ke(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function Pe(t, n) {
    if (n.tn) {
        return;
    }
    const e = n.Kt.shift();
    if (!e) {
        Te(t);
        return;
    }
    n.tn = Pf(e, () => {
        n.tn = null;
        Pe(t, n);
    }, e => {
        n.tn = null;
        ze(e);
        Te(t);
    });
    Rf(n.tn);
}

function Te(t) {
    const n = t.nn;
    if (n !== 2) {
        return;
    }
    t.nn = 3;
    t.en = void 0;
    const e = t.rn;
    t.rn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Ae(t) {
    const n = Ie(t);
    if (!n) {
        throw er(24);
    }
    return Me(n);
}

function Me(t) {
    const n = t;
    return n.qContainer ||= new fa(n);
}

function Ie(t) {
    return t.closest(jr);
}

const ua = [ Vd, vr, br ].map(t => `[${t.replace(":", "\\:")}]`).join(",");

function qe(t, n) {
    const e = t + "";
    const s = n?.closest(jr);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            ve(t, function* i(t, n, e, s, o, r) {
                yield* Se(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* ge(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        ia(t, () => {
            o.element.qContainer === o && Re(o, me(o, e));
        });
    }
}

const ca = new WeakSet;

class fa extends Yc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    $t=new WeakMap;
    Ye;
    Jt;
    Pt=null;
    vNodeLocate=t => Fl(this.rootVNode, t);
    nn=0;
    rn=void 0;
    en=void 0;
    Yt;
    Gt;
    Zt=null;
    Ge=null;
    Ze=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(xr);
        if (!this.qContainer) {
            throw er(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.Ue = t.getAttribute(Ar);
        this.Jt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = El(this.element);
        this.Yt = [];
        this.Gt = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= qe);
        this.Ye = Tr(n, this.Jt) || Ss;
        this.Ke();
        t.qContainer = this;
        t.qDestroy = () => this.an();
        if (__EXPERIMENTAL__.errorBoundary) {
            this.Ze = t => {
                const n = t.detail;
                if (n?.importError) {
                    return;
                }
                const e = n?.element;
                if (e && e.closest(jr) === this.element) {
                    const t = this.vNodeLocate(e);
                    if (t) {
                        try {
                            this.handleError(n.error, t, "event");
                        } catch (t) {
                            ze(t);
                        }
                    }
                }
            };
            this.document.addEventListener?.("qerror", this.Ze);
            (function t(n) {
                if (!n || typeof n.addEventListener !== "function" || ca.has(n)) {
                    return;
                }
                ca.add(n);
                n.addEventListener("unhandledrejection", t => {
                    ze(t?.reason);
                });
            })(n.defaultView);
        }
        this.nn = 1;
        (function e(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            ve(e, function* s(t) {
                yield* Se(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        ia(n, () => {
            this.nn === 1 && Re(this, this.tr());
        });
    }
    * tr() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Jt}"]:not(${mr})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${mr})`);
        if (n) {
            this.Yt = JSON.parse(n.textContent);
            yield* Dn(this.Yt, this);
            this.Zt = this.Pt;
            const e = this.Yt.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.Gt = s !== null && e > 0 && e >= +s ? yield* le(this, this.Yt) : Sf(this, this.Yt);
        }
        __EXPERIMENTAL__.suspense && (yield* me(this));
        this.nr();
        t.setAttribute(xr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    an() {
        if (this.Ze) {
            this.document.removeEventListener?.("qerror", this.Ze);
            this.Ze = null;
        }
        this.vNodeLocate = () => null;
        this.Yt.length = 0;
        this.Gt.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(xr);
        const n = t.ownerDocument;
        this.en = void 0;
        this.nn = 0;
        const e = n.querySelector(jr) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    nr() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Sr);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Jn(t, n) {
        this.Gt[t] = n;
    }
    parseQRL(t) {
        const n = jn(t, this);
        return n;
    }
    handleError(t, n, e = "render") {
        if (!__EXPERIMENTAL__.errorBoundary) {
            const e = n && this.resolveContext(n, Df);
            if (!e) {
                throw t;
            }
            e.error = t;
            return;
        }
        const s = t === void 0 ? Error("undefined") : t;
        let o = n;
        for (;o; ) {
            const n = this.resolveContextHost(o, Df);
            if (!n) {
                break;
            }
            const r = this.resolveContext(n, Df);
            if (r && r.error === void 0) {
                r.error = s;
                const o = this.getHostProp(n, zr);
                Hf(o?.onError$, t, {
                    phase: e,
                    boundaryId: r.boundaryId ?? ""
                });
                yn(this, n, 4);
                return;
            }
            if (r && r.error === null) {
                r.error = s;
                return;
            }
            if (n.dirty & 4) {
                ze(t);
                return;
            }
            o = this.getParentHost(n);
        }
        ((t, ...n) => {
            Be(!0, t, ...n);
        })(t);
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Rr);
        s == null && this.setHostProp(t, Rr, s = []);
        Qe(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Rr);
            if (e != null && Ye(e, n.id, 0)) {
                return Je(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    resolveContextHost(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Rr);
            if (e != null && Ye(e, n.id, 0)) {
                return t;
            }
            t = this.getParentHost(t);
        }
        return null;
    }
    resetErrorBoundary(t) {
        let n = this.resolveContextHost(t, Df);
        if (!n) {
            const e = t.node?.closest?.(ua);
            n = e ? this.resolveContextHost(this.vNodeLocate(e), Df) : null;
        }
        if (!n) {
            return;
        }
        const e = this.resolveContext(n, Df);
        if (!e) {
            return;
        }
        let s = this.getParentHost(n);
        for (;s && this.getHostProp(s, hr)?.bt === Kf; ) {
            s = this.getParentHost(s);
        }
        const o = s ?? e.resetOwner;
        if (!o) {
            return;
        }
        yn(this, o, 4);
        e.error = void 0;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (Ml(n)) {
                if (ql(n, hr, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        Nl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Br:
          case zr:
          case hr:
          case Rr:
          case Pr:
          case Lr:
            s = this._;
            break;

          case Hr:
          case Zr:
            s = parseInt;
            break;
        }
        return ql(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => $e(t, this.Gt);
    Qt(t) {
        return this.Zt?.[t];
    }
    getSyncFn(t) {
        const n = this.Ye[t];
        return n;
    }
    er(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, kr);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, kr, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ge == null) {
            this.Ge = new Set;
            const t = this.document.querySelectorAll(gr);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ge.add(e.getAttribute(Er));
            }
        }
        if (!this.Ge.has(n)) {
            this.Ge.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Er, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ke() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === ni) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.fn = {
            containerAttributes: t
        };
    }
}

let aa;

let ep;

if (De) {
    const t = Qc();
    t && (ep = new t);
}

function Ne(t) {
    if (ep) {
        const t = ep.getStore();
        if (t) {
            return t;
        }
    }
    if (aa === void 0) {
        const n = da();
        if (n && n.sn) {
            return n.sn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return aa;
}

function xe(t, n) {
    if (ep) {
        return ep.run(t, n);
    }
    const e = aa;
    try {
        aa = t;
        return n();
    } finally {
        aa = e;
    }
}

let ha;

const da = () => ha;

const pa = () => {
    const t = da();
    if (!t) {
        throw er(9);
    }
    return t;
};

const $a = () => {
    const t = da();
    if (!t || t.ln !== Wr) {
        throw er(10);
    }
    return t;
};

function Ce(t, n, ...e) {
    return Le.call(this, t, n, e);
}

function Le(t, n, e) {
    const s = ha;
    try {
        ha = t;
        return n.apply(this, e);
    } finally {
        ha = s;
    }
}

const ya = (t, n, e = Ae(n)) => {
    const s = Fl(e.rootVNode, n);
    const o = e.sn;
    o && function r(t) {
        if (ep) {
            ep.enterWith(t);
            return;
        }
        aa = t;
    }(o);
    const i = je(o, s, t);
    i.$ = e;
    return i;
};

function Oe(t, n, e) {
    const s = {
        m: n,
        ln: Wr,
        un: void 0,
        sn: t,
        $: e,
        cn: void 0
    };
    return s;
}

function je(t, n, e) {
    const s = t || (e && Ze(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        ln: e,
        un: void 0,
        sn: s,
        $: void 0
    };
    return o;
}

const wa = (t, ...n) => {
    if (typeof t === "function") {
        if (!ha) {
            return t(...n);
        }
        {
            const e = ha.un;
            try {
                ha.un = void 0;
                return t(...n);
            } finally {
                ha.un = e;
            }
        }
    }
    if (Fu(t)) {
        return t.untrackedValue;
    }
    return nc(t);
};

const ma = /*#__PURE__*/ Oe(void 0, void 0, void 0);

const _a = (t, n, e, s, o) => {
    const r = ma.un;
    const i = ma.$;
    try {
        ma.un = m(n, e, o);
        ma.$ = s;
        return Le(ma, t);
    } finally {
        ma.un = r;
        ma.$ = i;
    }
};

const va = (t, n, e, s, o) => {
    t instanceof oo && t.m !== n && n && (t.m = n);
    return _a(() => t.value, n, e, s, o);
};

const ba = () => da()?.m;

const Ea = () => {
    const t = da();
    if (t) {
        return t.ln;
    }
};

const ga = () => {
    const t = da();
    if (t) {
        return t.$;
    }
};

const Sa = t => t;

const ka = t => t.l || Promise.resolve();

let Ra;

let Pa = (t, n, e, s, o) => new Ta(t, n, e, s, o);

class Ta {
    Et;
    bt;
    rr;
    ir;
    $;
    constructor(t, n, e, s, o) {
        this.Et = t;
        this.bt = n;
        this.rr = e;
        this.ir = s;
        s && this.sr(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        We && t && Fe(t, .8);
    }
    get st() {
        return Wd(this.bt);
    }
    sr(t) {
        this.ir = t;
        si(t) && t.then(t => this.ir = t, t => {
            const n = `qrl ${this.bt} failed to load`;
            if (De) {
                console.error(n, t);
            } else if (We) {
                const e = this.Et === null ? "symbol:" + this.bt : "chunk:" + this.Et;
                const s = this.$;
                let o = s && Ra?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (Ra ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.ir = null;
        });
    }
    lr() {
        if (this.ir != null) {
            return this.ir;
        }
        if (this.Et === "") {
            const t = this.$.Jt;
            const n = this.$.element?.ownerDocument || document;
            const e = Tr(n, t);
            return this.ir = e[+this.bt];
        }
        We && this.Et && Fe(this.Et, 1);
        const t = this.bt;
        const n = this.rr ? this.rr().then(n => n[t]) : Pi().importSymbol(this.$?.element, this.Et, t);
        this.sr(n);
        return this.ir;
    }
}

We && import.meta.hot && (t => {
    if (!We || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Pa = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.Et;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.Et;
            if (i) {
                t.Et = e(i, o);
                r = !0;
            }
            const c = t.rr?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.rr = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.bt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.bt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.ir = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(Ta);

const Aa = Symbol();

const Ma = t => t?.[Aa] ?? t;

class Ia {
    ur;
    resolved=void 0;
    Nt;
    $;
    constructor(t, n, e) {
        this.ur = t;
        if (n) {
            this.Nt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.ir == null || this.Nt && typeof this.Nt === "string" || si(t.ir) || (this.resolved = Xa(this, t.ir));
    }
}

const qa = function(t, ...n) {
    const e = Ma(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = da();
    return Na.call(e, s?.$).then(() => Le.call(t, s, e.resolved, n));
};

const Na = async function(t) {
    const n = Ma(this);
    return li(Fa(n, t), () => n.resolved);
};

const xa = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Aa].resolved;
        },
        set(t) {
            this[Aa].resolved = t;
        }
    },
    Nt: {
        get() {
            return this[Aa].Nt;
        },
        set(t) {
            this[Aa].Nt = t;
        }
    },
    $: {
        get() {
            return this[Aa].$;
        },
        set(t) {
            this[Aa].$ = t;
        }
    },
    ur: {
        get() {
            return this[Aa].ur;
        }
    },
    Et: {
        get() {
            return this[Aa].ur.Et;
        }
    },
    bt: {
        get() {
            return this[Aa].ur.bt;
        }
    },
    st: {
        get() {
            return this[Aa].ur.st;
        }
    },
    dev: {
        get() {
            return this[Aa].ur.dev;
        }
    },
    cr: {
        value: qa
    },
    w: {
        value: function(t) {
            const n = Ma(this);
            const e = new Ia(n.ur, t, n.Nt ? n.$ : void 0);
            return Wa(e);
        }
    },
    s: {
        value: function(t) {
            const n = Ma(this);
            n.ur.sr(t);
            n.resolved = Xa(n, t);
        }
    },
    resolve: {
        value: Na
    },
    getSymbol: {
        value: function() {
            return Ma(this).ur.bt;
        }
    },
    getHash: {
        value: function() {
            return Ma(this).ur.st;
        }
    },
    getCaptured: {
        value: function() {
            const t = Ma(this);
            ja(t);
            return t.Nt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Ma(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Na.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Le(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Ca = null;

const La = t => {
    Ca = t;
};

const Oa = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t._(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const ja = t => {
    const n = t.Nt;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw er(13);
        }
        const s = mf;
        Ca = t.Nt = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return Oa(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return Oa(t, n, s + 1, o);
        })(e, n);
        if (mf !== s) {
            return mf;
        }
    } else {
        Ca = n || null;
    }
};

const Xa = (t, n) => {
    if (typeof n !== "function" || !t.Nt) {
        return n;
    }
    return function e(...s) {
        ja(t);
        return n.apply(this, s);
    };
};

const Fa = (t, n) => {
    const e = t.ur;
    const s = typeof t.Nt === "string";
    s && !t.$ && (t.$ = n || da()?.$);
    if (t.resolved) {
        return;
    }
    const o = Ba();
    const r = da();
    const i = e.lr();
    const c = li(i, n => {
        t.resolved = Xa(t, n);
    });
    if (c) {
        const t = e.bt;
        Ua(t, r?.m instanceof us ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && ja(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Da = (t, n, e, s, o, r) => {
    const i = Pa(t, n, s, e, r);
    const c = new Ia(i, o, r);
    return Wa(c);
};

const Wa = t => {
    const n = async function(...t) {
        return qa.call(n, this, ...t);
    };
    n[Aa] = t;
    Object.setPrototypeOf(n, xa);
    return n;
};

const Va = /*#__PURE__*/ new Set;

const Ua = (t, n, e) => {
    if (!Va.has(t)) {
        Va.add(t);
        za("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const za = (t, n) => {
    Ud() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const Ba = () => {
    if (Ud()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Ha = 0;

const Qa = t => Da(null, "s" + Ha++, t, null, null);

const Ja = Qa;

const Ya = t => t;

const Ga = t => Da("", rr, t, null, null);

const Za = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return Da("", rr, t, null, null);
};

const Ka = t => {
    function n(n, e, s = 0) {
        const o = t.st.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[th] = [ t ];
        return Eo(i, n, null, n.children, s, r);
    }
    n[th] = [ t ];
    return n;
};

const th = Symbol();

const nh = t => typeof t == "function" && t[th] !== void 0;

const eh = t => Ka(Ja(t));

const rh = Vs(Ya);

const ih = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const sh = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Zi(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(xr, "resumed");
    const s = Ae(t);
    s.fn = e.serverData || {};
    const o = s.rootVNode;
    Nl(o, ps, n);
    yn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            gt(s, [], s.rootVNode);
        }
    };
};

const oh = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ko();
    if (e != null) {
        return e;
    }
    const r = nr(t) ? Ce(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = rc(r, i, t);
        s(c);
        return c;
    }
};

const lh = t => {
    const n = (t => {
        const n = t.We;
        return n || t;
    })(t);
    return (t => t.toString(36))(n.Ve++);
};

const uh = () => {
    const {val: t, set: n, iCtx: e} = Ko();
    if (t != null) {
        return t;
    }
    const s = e.$.Ue || "";
    const o = s ? wi(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, hr);
    const i = r?.getHash().substring(0, 3) || "";
    const c = lh(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Xe(t, n) {
    const e = da();
    return e?.$?.fn[t] ?? n;
}

const ch = /*#__PURE__*/ new Map;

const fh = (t, n) => {
    let e = ch.get(n);
    e || ch.set(n, e = ah(t, n));
    return e;
};

const ah = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = yh;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Vh) {
            r++;
            e = Fh;
        }
        const s = Gh[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, w] = p;
            if (($ === l || $ === kh || $ === Rh && hh(l) || $ === Th && $h(l)) && (y === e || y === kh || y === Rh && hh(e) || y === Ph && !hh(e) && e !== Lh || y === Th && $h(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (w === gh || w == Sh) {
                    if (w === Sh) {
                        if (c !== wh || h()) {
                            if (!dh(e)) {
                                const t = y == Ph ? 1 : y == xh ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            dh(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === Ph) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || yh;
                        if (c === mh) {
                            u(r - 1);
                            i++;
                        }
                    } while (ph(c));
                } else {
                    o.push(c);
                    if (c === mh && w === yh) {
                        u(r - 8);
                        i = r;
                    } else {
                        w === _h && f(n);
                    }
                    c = w;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === mh || h()) {
            return;
        }
        u(t);
        s.push(".", pr, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ch) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ch) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | zh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(mh) !== -1 || o.indexOf(vh) !== -1;
    }
};

const hh = t => t >= Oh && t <= jh || t >= Fh && t <= Dh || t >= Bh && t <= Hh || t >= 128 || t === Uh || t === Ch;

const dh = t => t === Xh || t === Lh || t === Wh || t === Nh || hh(t);

const ph = t => t === bh || t === vh || t === Eh || t === mh;

const $h = t => t === qh || t === Ah || t === Mh || t === Ih;

const yh = 0;

const wh = 2;

const mh = 5;

const _h = 6;

const vh = 10;

const bh = 11;

const Eh = 12;

const gh = 17;

const Sh = 18;

const kh = 0;

const Rh = 1;

const Ph = 2;

const Th = 3;

const Ah = 9;

const Mh = 10;

const Ih = 13;

const qh = 32;

const Nh = 35;

const xh = 41;

const Ch = 45;

const Lh = 46;

const Oh = 48;

const jh = 57;

const Xh = 58;

const Fh = 65;

const Dh = 90;

const Wh = 91;

const Vh = 92;

const Uh = 95;

const zh = 32;

const Bh = 97;

const Hh = 122;

const Qh = 123;

const Jh = 125;

const Yh = /*@__PURE__*/ (() => [ [ kh, 39, 14 ], [ kh, 34, 15 ], [ kh, 47, 16, "*" ] ])();

const Gh = /*@__PURE__*/ (() => [ [ [ kh, 42, wh ], [ kh, Wh, 7 ], [ kh, Xh, _h, ":", "before", "after", "first-letter", "first-line" ], [ kh, Xh, mh, "global" ], [ kh, Xh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ kh, Xh, 4 ], [ kh, Rh, 1 ], [ kh, Lh, 1 ], [ kh, Nh, 1 ], [ kh, 64, vh, "keyframe" ], [ kh, 64, bh, "media", "supports", "container" ], [ kh, 64, Eh ], [ kh, Qh, 13 ], [ 47, 42, 16 ], [ kh, 59, gh ], [ kh, Jh, gh ], [ kh, xh, gh ], ...Yh ], [ [ kh, Ph, Sh ] ], [ [ kh, Ph, Sh ] ], [ [ kh, 40, yh ], [ kh, Ph, Sh ] ], [ [ kh, 40, 8 ], [ kh, Ph, Sh ] ], [ [ kh, 40, yh ], [ kh, Ph, gh ] ], [ [ kh, Ph, gh ] ], [ [ kh, 93, Sh ], [ kh, 39, 14 ], [ kh, 34, 15 ] ], [ [ kh, xh, gh ], ...Yh ], [ [ kh, Jh, gh ], ...Yh ], [ [ kh, Jh, gh ], [ Th, Rh, 1 ], [ kh, Xh, mh, "global" ], [ kh, Qh, 13 ], ...Yh ], [ [ kh, Qh, yh ], [ kh, 59, gh ], ...Yh ], [ [ kh, 59, gh ], [ kh, Qh, 9 ], ...Yh ], [ [ kh, Jh, gh ], [ kh, Qh, 13 ], [ kh, 40, 8 ], ...Yh ], [ [ kh, 39, gh ] ], [ [ kh, 34, gh ] ], [ [ 42, 47, gh ] ] ])();

const Zh = t => ({
    styleId: ed(t, t => t, !1)
});

const Kh = /*#__PURE__*/ Vs(Zh);

const td = t => ({
    scopeId: pr + ed(t, fh, !0)
});

const nd = /*#__PURE__*/ Vs(td);

const ed = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Ko();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${wi(t.st)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.er(n(t, c), c, l, e));
    }
    r.$.er(n(t.resolved, c), c, l, e);
    return c;
};

const rd = (t, n) => {
    t.resolve();
    return Hs(t, n);
};

const id = (t, n) => el(rd, t, n);

const sd = Vs(id);

const od = t => {
    t.resolve();
    return Js(t);
};

const ld = t => el(od, t);

const ud = Vs(ld);

const cd = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Ko();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Ud()) {
            e.h |= 32;
            fd(e, i);
        }
        return;
    }
    let c;
    if (Ud()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        yn(r.$, r.m, 1);
    }
    const l = new Ou(c, o, r.m, t, null);
    s(l);
    fd(l, i);
};

const fd = (t, n) => {
    n === "intersection-observer" ? af("qvisible", ad(t)) : n === "document-ready" ? hf("qinit", ad(t)) : n === "document-idle" && hf("qidle", ad(t));
};

const ad = t => Da(null, "_task", Mn, null, [ t ]);

const hd = Vs(uf);

const dd = /*#__PURE__*/ Vs(Cu);

const pd = /*#__PURE__*/ Vs(cd);

const $d = (t, n) => {
    t.resolve();
    return Qs(t, n);
};

const yd = (t, n) => el($d, t, n);

const wd = Vs(yd);

const md = /*#__PURE__*/ Of("qk-reveal");

const _d = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Ys(0)
});

const vd = () => {
    const t = Ca[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!We) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Gd(t);
};

const bd = ({cleanup: t}) => {
    const n = Ca[0];
    t(() => {
        if (!We) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Ed = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = el(_d, t);
    jf(md, n);
    const e = !We;
    if (__EXPERIMENTAL__.suspense && e && np()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!np()) {
                    return null;
                }
                const e = da()?.$;
                let s = 0;
                if (e) {
                    s = (Zd.get(e) || 0) + 1;
                    Zd.set(e, s);
                }
                return new Kd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = xf(e);
            return e;
        })(n);
        /*#__PURE__*/
        return bo(sp, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return bo(qo, null, null, null, 0, "u7_0");
};

const gd = /*#__PURE__*/ Ka(
/*#__PURE__*/ Fc(Ed, "_reC"));

const sp = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Qd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ bo(qo, null, null, null, 0, "u7_0"));
}) : null;

const Sd = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const op = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const kd = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const Rd = ({track: t, cleanup: n}) => {
    const e = Ca[0], s = Ca[1], o = Ca[2], r = Ca[3];
    const i = t(e.pending);
    const c = We;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Pd = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = nl("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return el(rl);
    })();
    const s = (t => {
        const n = Xf(md, null);
        const e = el(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Cu(/*#__PURE__*/ Fc(bd, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = id(
    /*#__PURE__*/ Fc(vd, "_reR", [ s ]));
    Cu(
    /*#__PURE__*/ Fc(Rd, "_suT", [ e, t, n, s ]));
    const r = !We;
    const i = r && np();
    const c = i ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = da()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && ap(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = i ? /*#__PURE__*/ Jc(Sd, [ t, n, o, s ], op) : null;
    const d = /*#__PURE__*/ Jc(kd, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = i ? /*#__PURE__*/ bo(rp, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, ro(t, "fallback"), 1, null) : /*#__PURE__*/ bo("div", {
        style: Jc(Sd, [ t, n, o, s ], op)
    }, null, ro(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ bo("div", null, i ? {
        [vr]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ bo(i ? ip : qo, i ? {
        [Lr]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [Lr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Td = /*#__PURE__*/ Ka(
/*#__PURE__*/ Fc(Pd, Kf));

const rp = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Qd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.delay;
    const i = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !ap(r) ? l.value = "fallback" : o && c && ap(r) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, r));
    s(
    /*#__PURE__*/ bo("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const ip = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Qd(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = __EXPERIMENTAL__.errorBoundary && e.parentComponentFrame ? t.resolveContext(e.parentComponentFrame.componentNode, Df) : void 0;
    const u = t.segment(o, function f(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return bo(qo, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return bo(qo, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    hp(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(u.then(n => async function e(t, n, s, o, r, i, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            await cp(t, n, s, o, i, !1);
        });
    }(t, s, o, n, i, c, r)).catch(t => {
        if (l) {
            if (l.At) {
                return l.At(t);
            }
            if (l.error !== void 0) {
                return;
            }
        }
        throw t;
    }));
}) : null;

async function cp(t, n, e, s, o, r) {
    const i = await s.container.P(e, s);
    (function c(t, n, e, s) {
        t.write(`<template ${_r}="${n}"${s?.attrs ?? ""}>`);
        t.write(e);
        t.write("</template>");
    })(t, n, i.html, o);
    t.emitOutOfOrderSegmentScripts(i.scripts);
    r && t.emitOutOfOrderExecutorIfNeeded();
    t.emitInlineScript(`qO(${n})`);
    const l = s.container.I;
    if (__EXPERIMENTAL__.errorBoundary && l.length) {
        t.emitErrorSwapExecutorIfNeeded();
        for (let n = 0; n < l.length; n++) {
            t.emitInlineScript(`qErr(${l[n]})`);
        }
    }
    await t.streamHandler.flush();
}

const lp = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Qd((t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = n.varProps.store;
    const r = "" + s;
    const i = async n => {
        const i = o.Tt;
        if (!i) {
            return;
        }
        Zf(o, n, "render");
        o.Tt = void 0;
        const c = Jd(o.error, Ve, t.A);
        const l = await t.segment(r, i(c), e);
        await async function u(t, n, e, s) {
            await t.S(() => cp(t, n, e, s, null, !0));
        }(t, s, r, l);
    };
    o.At = xf(i);
    hp(t, s);
    if (o.error !== void 0 && o.Tt) {
        return i(o.error);
    }
}) : null;

const up = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Qd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    if (r.error !== void 0 && r.Tt) {
        const n = r.Tt;
        r.Tt = void 0;
        const e = Jd(r.error, Ve, t.A);
        if (Ki(t)) {
            t.C(o);
            s(n(e));
        } else {
            s(() => {
                t.emitErrorSwapExecutorIfNeeded();
                t.emitInlineScript(`qErr(${o})`);
            });
            s(n(e));
        }
    }
}) : null;

const fp = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Qd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    const i = n.varProps.hostStyle;
    const c = __EXPERIMENTAL__.suspense && t.outOfOrderStreaming && !Ki(t) && (r.error === void 0 || (t => Qf.has(t))(r));
    s(
    /*#__PURE__*/ bo("div", {
        [c ? vr : Vd]: o + "",
        style: i
    }, null, 
    /*#__PURE__*/ bo(c ? lp : up, {
        boundaryId: o,
        store: r
    }, null, null, 1, null), 1, null));
}) : null;

function ap(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

function hp(t, n) {
    t.write(`<template ${_r}="${n}"></template>`);
}

const Ad = () => {
    const [t] = of();
    const n = da()?.$;
    n?.resetErrorBoundary && t && n.resetErrorBoundary(t);
};

const Md = t => {
    if (!__EXPERIMENTAL__.errorBoundary) {
        throw Error('<ErrorBoundary> requires the `errorBoundary` experimental feature. Enable it in your Qwik Vite config: qwikVite({ experimental: ["errorBoundary"] }).');
    }
    const n = (() => {
        const t = Object.defineProperty({}, "error", {
            value: void 0,
            writable: !0,
            enumerable: !1,
            configurable: !0
        });
        const n = oh(t);
        jf(Df, n);
        return n;
    })();
    const e = da();
    const s = e?.m;
    const o = e?.$;
    o && (Zu(n) ?? n).boundaryId === void 0 && (n.boundaryId = lh(o));
    const r = /*#__PURE__*/ Fc(Ad, "_ebR", [ s ]);
    const i = t.fallback$;
    n.Tt = xf(t => i(t, r));
    const c = t.onError$;
    n.Je = c ? xf((t, n) => c(t, n)) : void 0;
    const l = !We;
    if (__EXPERIMENTAL__.errorBoundary && l) {
        const t = e?.$?.getComponentFrame?.(0);
        n.resetOwner = t?.projectionComponentFrame?.componentNode ?? s?.parentComponent;
        return (t => {
            const n = (() => {
                if (!__EXPERIMENTAL__.errorBoundary) {
                    return 0;
                }
                const t = da()?.$;
                return t?.nextOutOfOrderId?.(!1) ?? 0;
            })();
            return [ 
            /*#__PURE__*/ bo("div", {
                [br]: n + "",
                style: "display:contents"
            }, null, 
            /*#__PURE__*/ bo(qo, null, null, null, 0, null), 1, null), 
            /*#__PURE__*/ bo(fp, {
                boundaryId: n,
                store: t,
                hostStyle: "display:none"
            }, null, null, 1, null) ];
        })(n);
    }
    if (n.error !== void 0) {
        const e = Jd(n.error);
        /*#__PURE__*/
        return bo(Mo, null, null, ((t, n, e) => {
            const s = t(n, e);
            if (s && typeof s.then === "function") {
                return s.catch(n => {
                    if (t.resolved !== void 0) {
                        throw n;
                    }
                    return (() => 
                    /*#__PURE__*/ bo("div", {
                        role: "alert"
                    }, null, "Something went wrong.", 0, null))();
                });
            }
            return s;
        })(t.fallback$, e, r), 0, null);
    }
    /*#__PURE__*/
    return bo(qo, null, null, null, 0, null);
};

const Id = 
/*#__PURE__*/ Ka(
/*#__PURE__*/ Fc(Md, "_ebC"));

const qd = async ({track: t}) => {
    const n = Ca[0];
    t(() => n.items);
    const e = da();
    const s = e.m;
    const o = e.$;
    yn(o, s, 256);
    const r = De;
    r && await o.l;
};

const Nd = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Cu(/*#__PURE__*/ Fc(qd, "_eaT", [ t ]));
    return No;
};

const xd = /*#__PURE__*/ Ka(
/*#__PURE__*/ Fc(Nd, "_eaC"));

const Cd = (t, n, e) => ir(t) ? t.getFn(n)(e) : t(e);

const Ld = ({track: t}) => {
    const n = Ca[0];
    const e = da();
    const s = e.m;
    const o = e.$;
    const r = De;
    return li(t(() => Cd(n.when$, da(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return li(i ? Cd(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Ut(s, n);
            yn(o, s, 2);
        });
    });
};

const Od = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Cu(/*#__PURE__*/ Fc(Ld, "_shT", [ t ]));
    return No;
};

const jd = /*#__PURE__*/ Ka(
/*#__PURE__*/ Fc(Od, "_shC"));

const Xd = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Fd.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return bo("script", null, o, null, 0, "prefetch-service-worker");
};

const Fd = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Dd = () => null;

globalThis.__qwik && er(30, [ globalThis.__qwik, Gi ]);

globalThis.__qwik = Gi;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { Qa as $, xd as Each, Id as ErrorBoundary, Mo as Fragment, Cf as NoSerializeSymbol, Dd as PrefetchGraph, Xd as PrefetchServiceWorker, sc as PublicError, Io as RenderOnce, cf as Resource, gd as Reveal, Co as SSRComment, xo as SSRRaw, Oo as SSRStream, Lo as SSRStreamBlock, Lf as SerializerSymbol, jd as Show, No as SkipRender, qo as Slot, Td as Suspense, ms as _CONST_PROPS, fa as _DomContainer, ts as _EFFECT_BACK_REF, Br as _ELEMENT_SEQ, Ss as _EMPTY_ARRAY, ks as _EMPTY_OBJ, Es as _IMMUTABLE, Yc as _SharedContainer, lo as _SubscriptionData, hc as _SubscriptionPatch, Ou as _Task, gs as _UNINITIALIZED, _s as _VAR_PROPS, ee as _addProjection, Ca as _captures, v as _chk, ye as _createDeserializeContainer, Da as _createQRL, qn as _createStore, ui as _delay, pe as _deserialize, Ic as _dumpState, Nd as _eaC, qd as _eaT, Md as _ebC, Ad as _ebR, pn as _executeSsrChores, Jc as _fnSignal, Qc as _getAsyncLocalStorage, qs as _getConstProps, ga as _getContextContainer, Ea as _getContextEvent, ba as _getContextHostElement, Ae as _getDomContainer, Ie as _getQContainerElement, m as _getSubscriber, Is as _getVarProps, tc as _hasStoreEffects, yf as _hmr, Bs as _injectAsyncSignalValue, Ce as _invoke, fo as _isJSXNode, ec as _isStore, Vn as _isStringifiable, ju as _isTask, Sa as _jsxBranch, go as _jsxC, ko as _jsxQ, So as _jsxS, bo as _jsxSorted, Eo as _jsxSplit, He as _mapApp_findIndx, Je as _mapArray_get, Qe as _mapArray_set, Qu as _markSignalAsExternallyOwned, je as _newInvokeContext, Dc as _noopQrl, Wc as _noopQrlDEV, Fn as _preprocessState, Za as _qrlSync, Ln as _qrlToString, Vc as _qrlWithChunk, Uc as _qrlWithChunkDEV, Ed as _reC, vd as _reR, bd as _reT, Hc as _regSymbol, se as _removeProjection, b as _res, Ff as _resolveContextWithoutSequentialScope, Wo as _restProps, n as _retryOnPromise, lf as _rsc, N as _run, de as _serialize, Kn as _setEvent, re as _setProjectionTarget, Od as _shC, Ld as _shT, Pd as _suC, Rd as _suT, Mn as _task, ie as _updateProjectionProps, ne as _useHmr, _ as _val, Af as _verifySerializable, Ll as _vnode_ensureElementInflated, ku as _vnode_getAttrKeys, iu as _vnode_getElementName, lu as _vnode_getFirstChild, ql as _vnode_getProp, Vl as _vnode_getVNodeForChildNode, Kl as _vnode_insertBefore, Rl as _vnode_isElementVNode, Tl as _vnode_isMaterialized, Al as _vnode_isTextVNode, Ml as _vnode_isVirtualVNode, Sl as _vnode_newVirtual, eu as _vnode_remove, Nl as _vnode_setProp, gn as _vnode_toString, ka as _waitUntilRendered, zn as _walkJSX, ro as _wrapProp, so as _wrapSignal, eh as component$, Ka as componentQrl, Zs as createAsync$, Qs as createAsyncQrl, Gs as createComputed$, Hs as createComputedQrl, Of as createContextId, E as createElement, Ks as createSerializer$, Js as createSerializerQrl, Ys as createSignal, rh as event$, Ya as eventQrl, Ku as forceStoreEffects, ih as getClientManifest, Ae as getDomContainer, Ne as getLocale, Pi as getPlatform, E as h, Vs as implicit$FirstArg, Fc as inlinedQrl, Bc as inlinedQrlDEV, Ve as isDev, Fu as isSignal, Po as jsx, To as jsxDEV, Ao as jsxs, xf as noSerialize, Xc as qrl, zc as qrlDEV, sh as render, Ri as setPlatform, Ga as sync$, wa as untrack, nc as unwrapStore, wd as useAsync$, yd as useAsyncQrl, sd as useComputed$, id as useComputedQrl, el as useConstant, Xf as useContext, jf as useContextProvider, uh as useId, of as useLexicalScope, af as useOn, hf as useOnDocument, df as useOnWindow, hd as useResource$, uf as useResourceQrl, ud as useSerializer$, ld as useSerializerQrl, Xe as useServerData, nl as useSignal, oh as useStore, Kh as useStyles$, Zh as useStylesQrl, nd as useStylesScoped$, td as useStylesScopedQrl, dd as useTask$, Cu as useTaskQrl, pd as useVisibleTask$, cd as useVisibleTaskQrl, Gi as version, xe as withLocale };
